// ===========================================================================
// CONTENT HUB — das gemeinsame Asset fuer BEIDE Dashboards.
// ===========================================================================
//
// 🔴 WARUM DIESE DATEI UEBERHAUPT EXISTIERT.
//
// Der Content-Hub stand bis zum 09.10.2026 in berater-dashboard.js. Dann fiel
// auf, dass es ZWEI Dashboards gibt: der Login verzweigt nach der
// WeClapp-Kategorie, "Kosmetikstudio" landet auf /pages/studio mit einem
// eigenen Layout, eigenem Stilblatt und eigenem Skript. Die Kosmetikstudios
// kamen am Hub also nie vorbei.
//
// Marcel am 09.10.2026: „Ja, mit eigener Bereichsauswahl. Mach Studio fertig."
//
// Der bequeme Weg waere gewesen, die 1700 Zeilen in studio-dashboard.js zu
// kopieren. Das waeren zwei Fassungen, die ab dem ersten Tag auseinander
// laufen — und dieses Projekt hat genau dafuer schon bezahlt: 'print' war im
// Admin noch eine Art und im Worker nicht mehr, und jede PDF wurde abgewiesen
// (08.10.2026). Zwei Listen mit derselben Bedeutung sind eine Falle, zwei
// Oberflaechen mit derselben Bedeutung sind dieselbe Falle in groesser.
//
// Also EIN Asset, das beide Layouts laden. Es ist durch Ausschneiden
// entstanden, nicht durch Neuschreiben: der Block ist Zeile fuer Zeile
// derselbe wie vorher, damit die Durchsicht moeglich bleibt.
//
// ---------------------------------------------------------------------------
// WAS DIESE DATEI VON IHREM GASTGEBER BRAUCHT
// ---------------------------------------------------------------------------
// Drei Dinge, und alle drei kommen ueber init() herein statt aus einer
// globalen Variablen:
//
//   workerBase  Die Adresse des provision-worker. 🔴 ALS PARAMETER UND NICHT
//               ALS EIGENE KONSTANTE: beide Dashboards haben sie schon
//               (berater-dashboard.js und studio-dashboard.js, je einmal).
//               Eine dritte Stelle waere die, die beim naechsten Umzug
//               stehenbleibt.
//   rolle       'berater' oder 'studio'. Entscheidet, welche Bereiche der
//               Worker liefert (Migration 0032). Steht im AUFRUF und wird
//               nicht aus der Adresse geraten: das Studio-Dashboard weiss, was
//               es ist, und eine Erkennung ueber window.location waere eine
//               Vermutung mit einer Fehlerquelle mehr.
//   escape      Kommt NICHT herein, sondern steht unten — es sind vier Zeilen
//               Zeichenersetzung ohne Fachwissen, und ein Helfer, den man
//               uebergeben muss, macht jeden Aufruf umstaendlicher als die
//               Dublette wiegt.
//
// ⚠️ DIE REIHENFOLGE DER SKRIPTE IM LAYOUT IST NICHT BELIEBIG. Diese Datei
// definiert window.SmContentHub, das Dashboard ruft es auf. Beide tragen
// `defer`, also laufen sie in der Reihenfolge ihrer <script>-Tags — und dieses
// Asset muss VOR dem Dashboard stehen. Steht es danach, ist SmContentHub beim
// Aufruf undefined und der Reiter bleibt leer. Der Aufruf selbst prueft das und
// sagt es in der Konsole, statt lautlos nichts zu tun.
// ===========================================================================

(function () {
  'use strict';

  // Sprachtexte (sm-i18n) ueber den Dashboard-Helfer assets/sm-dashboard-i18n.js;
  // ohne ihn steht der Schluessel da (Plan 2026-10-29-dashboard-i18n).
  var i18n = function (key, vars) { return window.smI18n ? window.smI18n(key, vars) : key; };
  // Bereichs- und Themennamen, Titel und Texte pflegt der Admin optional auch
  // englisch (name_en, titel_en, inhalt_en; Migration 0034 im provision-worker).
  // Ohne Helfer oder ohne englische Fassung gilt der deutsche Wert.
  var inhalt = function (de, en) { return window.smInhalt ? window.smInhalt(de, en) : de; };
  // Sichtbare Texte stehen als eigene Literale neben dem Markup
  //   ('<p>' + 'Text' + '</p>'):
  // ins Woerterbuch kommt nur der Text, nie ein Tag-Rest (Plan 2026-10-29-dashboard-i18n).
  // Texte werden erst beim Zeichnen gebildet, nie schon beim Laden der Datei.
  // Kein Warten auf smI18nBereit noetig: diese Datei zeichnet beim Laden nichts,
  // init() ruft erst das Dashboard beim Oeffnen des Reiters (nach seinem Start).

  // Spiegelt escape() aus berater-dashboard.js. Siehe Kopf: eine Dublette von
  // vier Zeilen gegen einen Parameter an jedem Aufruf.
  function escape(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Wird von init() gesetzt. Kein Vorgabewert: eine geratene Adresse waere
  // schlimmer als ein Fehler, den man sieht.
  let PROVISION_WORKER_BASE = '';
  // 'berater' | 'studio' — geht als ?rolle= an den Worker (Migration 0032).
  let ROLLE = 'berater';

  // ============================================================
  // CONTENT HUB (Reiter „Content Hub" — Marketing-Material, Aufgabe 7)
  // ============================================================
  // Die SICHTBARE Seite des Content-Hubs. 150 Beraterinnen arbeiten damit,
  // ueberwiegend am Handy.
  //
  // API (provision-worker, KEINE Authentifizierung — Begruendung im Kopf von
  // src/api/content-berater.js):
  //   GET /api/content/struktur                            Bereiche, Tags, Produkte
  //   GET /api/content/medien?bereich=&typ=&tag=&produkt=   sichtbare Medien
  //   GET /api/content/download/:id                         signierte Adresse, 15 Min
  //
  // ---------------------------------------------------------------------------
  // DIE EINSTIEGSSEITE LAEDT UNGEFILTERT — IST ABER FILTERBAR
  // ---------------------------------------------------------------------------
  // 🔴 HIER HAT SICH DIE ANSAGE GEAENDERT, und die juengere gilt.
  //
  // Die Vorlage von Marcels Kolleginnen (06.10.2026) sagte woertlich: „Es
  // duerfen keine Filter hinterlegt sein." Marcel am 08.10.2026, nach dem
  // ersten Durchgang mit echtem Material: „Bitte ueberall Filter mit
  // Video/Foto hinzunehmen."
  //
  // Beides geht zusammen, weil die Vorlage den LADEZUSTAND meint und nicht ein
  // Verbot: /api/content/medien OHNE jeden Parameter liefert alles Sichtbare
  // ueber alle Bereiche, und genau so geht die Seite auf. chAbfrage({}) liefert
  // deshalb weiter einen LEEREN Abfrageteil — kein typ= und kein bereich= mit
  // leerem Wert. Wer dann auf „Videos" tippt, filtert; wer nichts tippt, sieht
  // alles. „Ungefiltert geladen, aber filterbar" ist die Lesart, die beide
  // Ansagen erfuellt.
  //
  // Die Bereiche sind die Vertiefung. Welche Achsen eine Ansicht hat, ergibt
  // sich AUS DEN DATEN (chAchsen) und steht — bis auf eine Ausnahme, siehe
  // gleich — nirgends im Code: bei „04 Produkte" haengen Schlagwoerter, bei
  // „07 Print" andere, bei den uebrigen fuenf keine. Wird im Admin ein Tag
  // verschoben, wandert die Leiste mit.
  //
  // DREI ACHSEN, DREI REICHWEITEN:
  //   Art      ueberall, auch auf „Alles" (Marcel 08.10.2026). Der Wertevorrat
  //            kommt aus /api/content/struktur (medientypen).
  //   Thema    nur in einem Bereich, und nur die Tags dieses Bereichs plus die
  //            globalen.
  //   Produkt  NUR im Produktbereich (Marcel 08.10.2026: „Produktfilter
  //            entfernen -> das gilt fuer alle Seiten ausser 04 Produkt").
  //            Erkannt wird er am NAMEN, nicht an der Nummer und nicht an der
  //            ID — Begruendung bei chIstProduktBereich.
  //
  // ---------------------------------------------------------------------------
  // 🔴 DIE TITELZEILE STEHT AUF „ALLES" NUR, WO DAS BILD NICHTS SAGT
  // ---------------------------------------------------------------------------
  // Marcel am 08.10.2026: „Bei ‚Alles', bitte Titel rausnehmen und Titel nur
  // bei Flyer behalten. Eventuell nur sichtbar wenn man mit Maus drauf geht."
  //
  // Der Maus-Vorschlag ist NICHT umgesetzt, und das ist Absicht: das Dashboard
  // wird ueberwiegend am Handy benutzt, und dort gibt es kein Hovern. Ein
  // Titel, den nur eine Maus hervorholt, ist fuer 150 Beraterinnen kein
  // versteckter Titel, sondern keiner. Stattdessen:
  //
  //   Kachel MIT Vorschaubild  ->  der Titel wandert als kleine Zeile AUF das
  //                                Bild (.sm-ch-card__bildtitel). Die laute
  //                                Titelzeile im Kachelkoerper ist weg, der
  //                                Name bleibt ohne Maus, ohne Tipp und auf
  //                                jedem Geraet lesbar.
  //   Kachel OHNE Vorschaubild ->  die Titelzeile bleibt, wie sie war.
  //   Druckdatei (.pdf/.docx)  ->  die Titelzeile bleibt ebenfalls.
  //
  // Die beiden letzten Faelle sind Marcels „Flyer": wo nur ein 📄 steht, sehen
  // ein Flyer und ein Roll-Up identisch aus. Wie das erkannt wird und was
  // daran haengt, steht bei chZeigtTitel — dort auch, warum NICHT der Bereich
  // „07 Print" die Grundlage ist.
  //
  // In einem BEREICH bleibt die Titelzeile immer. Marcel hat nur „Bei ‚Alles'"
  // gesagt, und in einer Liste von vier Flyern ist der Name die einzige
  // Unterscheidung.
  //
  // ---------------------------------------------------------------------------
  // 🔴 TEILEN ENTSCHEIDET DER MEDIENTYP, NICHT DER BEREICH
  // ---------------------------------------------------------------------------
  // Marcel am 07.10.: „Alles teilbar machen, was Bild und Video ist, nicht nur
  // in Kampagnen." Also: foto und video sind teilbar, in JEDEM Bereich; text
  // nicht — der wird kopiert. Das ist eine reine Anzeigeregel (chAktionen) und
  // kein Datenfeld.
  //
  // UND SIE HAENGT AM BROWSER, NICHT AM BILDSCHIRM. navigator.share() mit
  // DATEIEN gibt es praktisch nur auf Mobilgeraeten; am Rechner existiert die
  // Funktion teils auch, aber ohne WhatsApp, Instagram oder TikTok dahinter.
  // Geprueft wird deshalb mit navigator.canShare({ files: [...] }) und einer
  // winzigen Probedatei — NIE an der Bildschirmbreite: ein iPad im Querformat
  // ist kein Desktop. Kann der Browser es nicht, steht dort „Herunterladen" und
  // KEIN toter Teilen-Knopf.
  //
  // ⚠️ DIE NUTZERGESTE. navigator.share() verlangt in Safari eine frische
  // Nutzergeste. Ein 130-MB-Video braucht aber Sekunden bis Minuten, und nach
  // dem await ist die Geste verbraucht — die Folge ist ein NotAllowedError.
  // Deshalb: nach dem Laden wird einmal direkt versucht (Chrome auf Android
  // traegt das), und wenn der Browser die Geste einfordert, wird die Datei im
  // Einplatz-Zwischenlager (chLager) behalten und der Knopf heisst „Jetzt
  // teilen" — der zweite Tipp hat eine frische Geste und die Datei liegt schon
  // da. Das Zwischenlager hat genau EINEN Platz, weil dort 130 MB liegen.
  //
  // ---------------------------------------------------------------------------
  // ⚠️ DER TEXTINHALT STEHT NICHT IN /medien — UND ES GIBT ZWEI ARTEN VON TEXT
  // ---------------------------------------------------------------------------
  // Die Medienliste fuehrt Titel, Art, Groesse und das signierte Vorschaubild —
  // aber nie den Inhalt. Geholt wird er beim Antippen, und ab Migration 0030
  // auf ZWEI Wegen, je nachdem, wo er liegt:
  //
  //   EINGETIPPTER TEXT (hat_inhalt = 1)
  //     Der Inhalt steht in D1. Geholt wird er ueber text_pfad
  //     (/api/content/text/:id) — EINE Anfrage an den Worker, fertig.
  //     🔴 UND DAS IST DER GEWINN: dieser Weg braucht KEIN CORS am Bucket, es
  //     gibt keine signierte Adresse und keine 15-Minuten-Frist. Marcel am
  //     07.10.2026: "eigentlich wollte ich ja den Text in ein Textfeld packen,
  //     und dann kann man den anzeigen bzw. kopieren."
  //
  //   TEXTDATEI IN R2 (hat_inhalt = 0, Endung .txt)
  //     Der alte Weg, und er bleibt: erst die signierte Download-Adresse holen,
  //     dann die Datei ueber fetch() gegen den R2-Host lesen. Das geht nur bei
  //     einer .txt — der Medientyp 'text' erlaubt im Worker auch .pdf und
  //     .docx, und deren Bytes als Text in die Zwischenablage zu legen waere
  //     Zeichensalat. Solche Medien bekommen einen Herunterladen-Knopf
  //     (chTextLesbar).
  //
  // Dass BEIDE Wege bestehen bleiben, ist Absicht: hochgeladene .txt-Dateien
  // aus der Zeit vor 0030 muessen weiter lesbar sein.
  //
  // 🔴 DER ZEICHENGLEICHE DURCHLAUF ENDET HIER, und hier brechen die Absaetze.
  // Zwei Dinge tragen das, und beide muessen stimmen:
  //
  //   1. textContent UND NIE innerHTML. HTML faltet jeden Zeilenumbruch zu
  //      einem Leerzeichen — per innerHTML gesetzt waere die Caption ein Block,
  //      und '<' oder '&' im Text wuerden als Markup gedeutet. Der Textleser
  //      setzt deshalb ausschliesslich textContent.
  //   2. white-space: pre-wrap IM CSS (.sm-ch-textbox in
  //      berater-dashboard.css). Ohne sie faltet der Browser die Umbrueche
  //      beim DARSTELLEN — der Text waere richtig im DOM und falsch auf dem
  //      Schirm. Der Test prueft beides (contenthub.test.mjs liest Quelle und
  //      Stilblatt).
  //
  // Die Zwischenablage bekommt immer den UNVERAENDERTEN Text, nie den
  // dargestellten: navigator.clipboard.writeText(text) und nicht etwa
  // innerText eines Elements — das brachte die Umbrueche der DARSTELLUNG und
  // nicht die des Textes.
  //
  // 🔴 TEILEN und das Lesen einer TEXTDATEI brauchen einen fetch() gegen den
  // R2-Host und damit eine CORS-Regel am Bucket skinmade-content fuer die
  // Dashboard-Herkunft. Vorschaubilder (als Bildquelle), der schlichte Download
  // (Navigation) und der EINGETIPPTE Text (Worker) brauchen sie NICHT.
  // Schlaegt der fetch fehl, bietet die Kachel das Herunterladen an und sagt,
  // dass es nicht am Material liegt.

  // Arten, die sich teilen lassen. Entscheidet der Medientyp — siehe Kopf.
  const CH_TEILBAR = ['foto', 'video'];
  // Endungen, deren Inhalt sich als Text lesen und kopieren laesst.
  const CH_TEXT_ENDUNGEN = ['txt'];

  // RUECKFALL fuer die Art-Filterleiste. Der Wertevorrat kommt aus
  // /api/content/struktur (medientypen) — so steht er an EINER Stelle, im
  // Worker, und ein neuer Typ erscheint hier von selbst.
  //
  // ⚠️ Der Rueckfall ist noetig, weil die Leiste seit Marcels Ansage vom
  // 08.10.2026 auch auf „Alles" steht: faellt /struktur aus (dort wird der
  // Fehler bewusst verschluckt, damit die Liste trotzdem laedt), waere ohne ihn
  // der Art-Filter ueberall weg — und das war genau der Zustand, den Marcel
  // beanstandet hat. Die drei Werte decken sich mit MEDIENTYPEN in
  // src/api/content-medien.js.
  const CH_ARTEN = ['foto', 'video', 'text'];

  // ⚠️ CH_DRUCK_ENDUNGEN (['pdf','docx']) STAND HIER UND IST WEG.
  //
  // Sie trug bis zum 08.10.2026 die Entscheidung, welche Kachel auf „Alles"
  // ihre Titelzeile behaelt: Druckdateien behielten sie, Bilder nicht. Marcels
  // neue Ansage ist eine andere — „bildtitel nur bei Print anzeigen, sonst
  // brauchen wir es nicht" —, und sie haengt am BEREICH und nicht an der
  // Datei. Die Liste stehen zu lassen hiesse, zwei Regeln fuer dieselbe Frage
  // zu haben, von denen eine nichts mehr tut. Siehe chZeigtTitel.
  // Obergrenze fuer den Textleser. Was darueber liegt, ist kein Textbaustein
  // zum Einfuegen in einen Beitrag, sondern eine Datei — und 5 MB in einem
  // <div> legen das Handy lahm.
  const CH_TEXT_MAX_BYTES = 200 * 1024;

  // Als Funktion und nicht als Festwert: die Texte werden erst beim Zeichnen
  // gebildet, nicht schon beim Laden der Datei (Plan 2026-10-29-dashboard-i18n).
  function chTypLabels() { return { foto: i18n('dashboard.contentHub.typ.foto'), video: i18n('dashboard.contentHub.typ.video'), text: i18n('dashboard.contentHub.typ.text') }; }
  const CH_TYP_PLATZ  = { foto: '🖼️', video: '🎬', text: '📄' };

  // Der Inhaltstyp der Datei, damit das System-Teilen-Menue die richtigen Apps
  // anbietet. R2 liefert ihn ueblicherweise mit; ein leerer Content-Type macht
  // aber aus einem Video eine „Datei", und WhatsApp zeigt sie dann nicht als
  // Video an. Die Endung ist hier die verlaesslichere Quelle.
  const CH_MIME_JE_ENDUNG = {
    jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp',
    mp4: 'video/mp4', mov: 'video/quicktime', webm: 'video/webm',
    pdf: 'application/pdf', txt: 'text/plain',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  };

  // --- Reine Helfer (ohne DOM und ohne Netz, deshalb pruefbar) ---------------

  function chEndung(dateiname) {
    const name = String(dateiname == null ? '' : dateiname).trim();
    const punkt = name.lastIndexOf('.');
    if (punkt < 1 || punkt === name.length - 1) return null;
    const endung = name.slice(punkt + 1).toLowerCase();
    return /^[a-z0-9]{1,8}$/.test(endung) ? endung : null;
  }

  function chMimeTyp(dateiname) {
    const endung = chEndung(dateiname);
    return (endung && CH_MIME_JE_ENDUNG[endung]) || '';
  }

  // Dezimalzeichen je Sprache ueber smFmt (assets/sm-dashboard-i18n.js, im
  // Layout vor diesem Skript; Plan 2026-10-29-dashboard-i18n): smFmt.zahl(0.5, 1)
  // ist "0,5" auf Deutsch und "0.5" auf Englisch. toFixed bleibt stehen — so ist
  // die deutsche Ausgabe zeichengleich ("1023,9 MB" ohne den Tausenderpunkt, den
  // smFmt.zahl setzen wuerde). Ohne Helfer wie bisher das Komma.
  function chKomma() {
    return window.smFmt ? window.smFmt.zahl(0.5, 1).charAt(1) : ',';
  }

  // Spiegelt ctBytes aus admin-dashboard.js — damit dieselbe Datei im Admin und
  // im Dashboard dieselbe Groessenangabe traegt.
  function chBytes(bytes) {
    // Eine FEHLENDE Angabe ist keine 0: „0 B" waere die Behauptung, die Datei
    // sei leer. Number(null) ist 0, deshalb wird null hier eigens abgefangen.
    if (bytes === null || bytes === undefined || bytes === '') return '—';
    const n = Number(bytes);
    if (!Number.isFinite(n) || n < 0) return '—';
    if (n < 1024) return n + ' B';
    const kb = n / 1024;
    if (kb < 1024) return Math.round(kb) + ' kB';
    const mb = kb / 1024;
    if (mb < 1024) return mb.toFixed(1).replace('.', chKomma()) + ' MB';
    return (mb / 1024).toFixed(2).replace('.', chKomma()) + ' GB';
  }

  function chTypLabel(medientyp) {
    const typ = String(medientyp || '');
    return chTypLabels()[typ] || typ || '—';
  }

  // Das Symbol einer Kachel ohne Vorschaubild.
  //
  // `hatInhalt` ist OPTIONAL und unterscheidet den eingetippten Text (0030) von
  // der Textdatei: ein eingetippter Text bekommt 📝 statt 📄. Begruendung: er
  // hat NIE ein Vorschaubild (es gibt keine Datei, aus der sich eines greifen
  // liesse), waehrend bei einer PDF einfach noch keines hinterlegt ist. Zwei
  // verschiedene Lagen sollen nicht gleich aussehen.
  //
  // Der zweite Parameter ist nachgetragen und nicht Pflicht — Aufrufe mit
  // einem Argument verhalten sich unveraendert.
  function chPlatzhalter(medientyp, hatInhalt) {
    if (hatInhalt) return '📝';
    return CH_TYP_PLATZ[String(medientyp || '')] || '📄';
  }

  // „01 Kampagnen". Fehlt die Nummer, steht nur der Name da — kein fuehrendes
  // Leerzeichen und kein Strich fuer nichts.
  function chBereichLabel(bereich) {
    const b = bereich || {};
    const nummer = String(b.nummer == null ? '' : b.nummer).trim();
    const roh = inhalt(b.name, b.name_en);
    const name = String(roh == null ? '' : roh).trim();
    if (nummer && name) return nummer + ' ' + name;
    return name || nummer || '—';
  }

  // Bereichs- und Themennamen sind INHALT (D1 content_bereiche/content_tags).
  // Die englische Fassung kommt seit 30.10.2026 aus den Daten (name_en, im
  // Admin pflegbar) und nicht mehr aus dem Woerterbuch. Die Erkennung in
  // chIstProduktBereich/chIstPrintBereich liest weiter den DEUTSCHEN b.name
  // und ist davon unberuehrt.

  /**
   * IST DAS EIN EINGETIPPTER TEXT (Migration 0030)?
   *
   * Entscheidet die Spalte hat_inhalt, die /api/content/medien je Zeile
   * mitliefert — nicht das Praefix von r2_key (den gibt die Berater-Liste
   * ohnehin nicht heraus) und nicht die Dateiendung (es gibt keine Datei).
   *
   * Ein eingetippter Text ist IMMER lesbar: er kommt aus D1, der Worker hat ihn
   * beim Anlegen gegen dieselbe 200-kB-Grenze geprueft, und es gibt keine
   * Endung, die Zeichensalat liefern koennte. Deshalb hier KEINE Pruefung auf
   * Endung oder Groesse — anders als bei chTextLesbar, wo beide noetig sind.
   */
  function chHatInhalt(medium) {
    return Number((medium || {}).hat_inhalt) === 1;
  }

  // Laesst sich der Inhalt dieses Mediums als DATEI lesen und kopieren?
  // Nur Typ 'text' UND eine Endung, die wirklich Text ist, UND klein genug.
  //
  // 🔴 NICHT FUER EINGETIPPTE TEXTE. Die haben keinen Dateinamen (dateiname ist
  // ''), chEndung liefert dort null, und diese Funktion sagte deshalb von sich
  // aus false — richtig, aber aus dem falschen Grund. Damit niemand sich auf
  // diesen Zufall verlaesst, steht die Bedingung ausdruecklich da: fuer einen
  // eingetippten Text ist chHatInhalt zustaendig.
  function chTextLesbar(medium) {
    const m = medium || {};
    if (chHatInhalt(m)) return false;
    if (String(m.medientyp || '') !== 'text') return false;
    const endung = chEndung(m.dateiname);
    if (!endung || CH_TEXT_ENDUNGEN.indexOf(endung) === -1) return false;
    const groesse = Number(m.groesse_bytes);
    // Eine unbekannte Groesse wird zugelassen: der Leser prueft sie dann noch
    // einmal an der Antwort. Eine bekannte, zu grosse wird abgelehnt.
    if (Number.isFinite(groesse) && groesse > CH_TEXT_MAX_BYTES) return false;
    return true;
  }

  function chTeilbar(medium, kannDateienTeilen) {
    const m = medium || {};
    // Ein eingetippter Text hat keine Datei — navigator.share({ files }) haette
    // nichts zu uebergeben. Er wird kopiert, nicht geteilt. Die Pruefung steht
    // vor der Typpruefung, weil ein eingetippter Text medientyp 'text' hat und
    // damit ohnehin nicht in CH_TEILBAR stuende; sie steht trotzdem da, damit
    // die Regel nicht auf diesem Zufall ruht.
    if (chHatInhalt(m)) return false;
    const typ = String(m.medientyp || '');
    return !!kannDateienTeilen && CH_TEILBAR.indexOf(typ) !== -1;
  }

  /**
   * DIE FALLUNTERSCHEIDUNG DER KNOEPFE — der Kern dieses Reiters.
   *
   * EINGETIPPTER TEXT (0030) -> „Text kopieren" (Haupt) plus „Anzeigen".
   *   Steht ZUERST, weil dieser Fall den anderen nie ueberlassen werden darf:
   *   er hat keine Datei, und jeder Download-Knopf darauf liefe in eine 409.
   *   KEIN Download — Marcels Vorlage sagt „Texte (bitte als copy paste!)".
   * Bild/Video und der Browser kann Dateien teilen -> „Teilen" (Haupt) plus
   *   „Herunterladen" (die Beraterin will es oft auch in der Galerie haben).
   * Bild/Video und der Browser kann es NICHT -> nur „Herunterladen". Kein
   *   toter Teilen-Knopf.
   * Text als .txt -> „Text kopieren" (Haupt) plus „Anzeigen". KEIN Download.
   * Text als .pdf/.docx (oder zu gross) -> „Herunterladen". Deren Bytes als
   *   Text in die Zwischenablage zu legen waere Zeichensalat.
   *
   * DIE BESCHRIFTUNGEN SIND FUER BEIDE TEXTARTEN DIESELBEN, und das ist
   * Absicht: fuer die Beraterin ist ein Text ein Text. Wo er liegt, ist eine
   * Frage der Pflege und keine ihrer Bedienung — den Unterschied traegt
   * holeText() intern.
   *
   * @returns {Array<{art: string, label: string, haupt: boolean}>}
   */
  function chAktionen(medium, kannDateienTeilen) {
    if (chHatInhalt(medium) || chTextLesbar(medium)) {
      return [
        { art: 'textkopieren', label: i18n('dashboard.contentHub.aktion.textKopieren'), haupt: true },
        { art: 'textzeigen', label: i18n('dashboard.contentHub.aktion.anzeigen'), haupt: false },
      ];
    }
    if (chTeilbar(medium, kannDateienTeilen)) {
      return [
        { art: 'teilen', label: i18n('dashboard.contentHub.aktion.teilen'), haupt: true },
        { art: 'download', label: i18n('dashboard.contentHub.aktion.herunterladen'), haupt: false },
      ];
    }
    return [{ art: 'download', label: i18n('dashboard.contentHub.aktion.herunterladen'), haupt: true }];
  }

  /**
   * BEREICHSNAME FUER DEN VERGLEICH — klein und ohne Umlaute.
   *
   * Fuer chIstProduktBereich und chIstPrintBereich. normalize('NFD') waere
   * eleganter, loest aber „ß" nicht auf und ist auf aelteren Android-Browsern
   * nicht verlaesslich.
   */
  function chNameNorm(wert) {
    return String(wert == null ? '' : wert)
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss');
  }

  /**
   * IST DAS DER PRODUKTBEREICH?
   *
   * Marcel am 08.10.2026: „Produktfilter entfernen -> das gilt fuer alle Seiten
   * ausser 04 Produkt."
   *
   * 🔴 ERKANNT AM NAMEN, NICHT AN DER NUMMER UND NICHT AN DER ID. Drei Wege
   * waeren denkbar, zwei davon brechen:
   *
   *   Nummer „04"   Die Nummer ist ein freies Textfeld im Admin und die
   *                 Reihenfolge ist umstellbar. Wird ein Bereich eingeschoben,
   *                 ist „04" ein anderer — und der Produktfilter stuende
   *                 ploetzlich bei „04 Hautanalyse".
   *   ID            Im Produktionsstand hat „Produkte" die ID 3, NICHT 4. Eine
   *                 festverdrahtete 4 traefe „05 Skinmade Sessions". Und IDs
   *                 sind beim Neuanlegen eines Bereichs andere.
   *   NAME          Das Wort „Produkt" IST, was diesen Bereich zum
   *                 Produktbereich macht. Umbenennen auf „Produkte & Sets",
   *                 „Pflegeprodukte" oder „Produkt-Fotos" trifft weiter,
   *                 Umsortieren und Umnummerieren sind ihm gleich.
   *
   * ⚠️ DER HAKEN, und er ist zu nennen: eine Umbenennung auf ein Synonym ohne
   * das Wort „Produkt" (etwa „Sortiment") schaltet den Filter lautlos ab. Das
   * ist der Preis dafuer, dass es in content_bereiche keine Spalte gibt, die
   * einen Bereich als Produktbereich AUSWEIST. Mit einer solchen Spalte (oder
   * mit einer Bereichsangabe je Produktzeile in /api/content/struktur) waere
   * die Achse datengetragen statt namensgetragen — das ist der saubere Umbau,
   * und er gehoert in den Worker.
   *
   * Dass die ZUORDNUNG weiter in jedem Bereich gilt, bleibt unberuehrt: ein
   * Kampagnenfoto darf dasselbe Produkt tragen wie das Produktfoto. Nur der
   * FILTER verschwindet (so steht es auch im Erklaertext des Admin).
   */
  function chIstProduktBereich(bereich) {
    return chNameNorm((bereich || {}).name).indexOf('produkt') !== -1;
  }

  /**
   * IST DAS DER PRINT-BEREICH?
   *
   * Marcel am 08.10.2026: „bildtitel nur bei Print anzeigen, sonst brauchen
   * wir es nicht."
   *
   * 🔴 ERKANNT AM NAMEN — DASSELBE VERFAHREN WIE BEI chIstProduktBereich, und
   * zwar ausdruecklich dasselbe und kein zweites. Zwei Wege, einen Bereich zu
   * erkennen, laufen auseinander, sobald jemand den einen anpasst.
   *
   *   Nummer „07"   Die Nummer ist ein freies Textfeld im Admin und die
   *                 Reihenfolge ist umstellbar. Wird ein Bereich
   *                 eingeschoben, ist „07" ein anderer — und der Titel stuende
   *                 ploetzlich bei „07 Berater Gewinn".
   *   ID            Im Produktionsstand hat „Produkte" die ID 3, NICHT 4 — die
   *                 IDs folgen der ALTEN Gliederung. Fuer „Print" gilt
   *                 dasselbe, und beim Neuanlegen eines Bereichs sind sie
   *                 ohnehin andere.
   *   NAME          Das Wort „Print" IST, was diesen Bereich zum Print-Bereich
   *                 macht. Umbenennen auf „Print & Druck", „Druckvorlagen
   *                 (Print)" oder „Print-Material" trifft weiter.
   *
   * ⚠️ DER HAKEN, und er ist derselbe wie beim Produktbereich: eine
   * Umbenennung auf ein Synonym ohne das Wort „Print" (etwa „Druckvorlagen")
   * schaltet die Titelzeile lautlos ab. Das ist der Preis dafuer, dass es in
   * content_bereiche keine Spalte gibt, die einen Bereich als Print-Bereich
   * AUSWEIST. Mit einer solchen Spalte waere die Regel datengetragen statt
   * namensgetragen — das ist der saubere Umbau, und er gehoert in den Worker.
   * Und er ist hier harmloser als beim Riegel „Arten je Bereich" (der steht
   * deshalb in content_bereich_arten und nicht im Code): dort wuerde ein
   * falscher Treffer Material in den falschen Bereich lassen, hier wird nur
   * eine Zeile leiser — der Titel bleibt ueber den Tipp auf das Bild und ueber
   * die Vorlesebeschriftung erreichbar.
   */
  function chIstPrintBereich(bereich) {
    return chNameNorm((bereich || {}).name).indexOf('print') !== -1;
  }

  /**
   * DIE ARTEN, DIE IN EINER ANSICHT ZUR WAHL STEHEN.
   *
   * Marcel am 08.10.2026: „Texte nur bei Skinmade Sessions und Berater
   * gewinnen."
   *
   * 🔴 DIE LISTE STEHT NICHT HIER, SONDERN KOMMT JE BEREICH AUS /struktur
   * (bereiche[].arten, Migration 0031). Eine Zuordnung im JavaScript —
   * { 'Skinmade Sessions': [...] } — braeche beim ersten Umbenennen im Admin,
   * und zwar lautlos: der Bereich haette dann keine Texte mehr, ohne dass
   * irgendwo stuende, warum. Begruendung im Kopf der Migration.
   *
   * Was /struktur je Bereich liefert, ist bewusst die VEREINIGUNG aus der
   * Festlegung und den Arten, die dort TATSAECHLICH liegen — damit ein Text,
   * der vor der Festlegung in „03 Hautanalyse" geladen wurde, dort weiter
   * auffindbar bleibt. Diese Funktion muss das nicht wissen; sie liest ab.
   *
   * AUF DER EINSTIEGSSEITE („Alles") GIBT ES KEINEN BEREICH. Entschieden:
   * die VEREINIGUNG aller sichtbaren Bereiche.
   *
   *   Warum nicht der volle Wertevorrat (foto, video, text)? Weil er eine
   *   Behauptung waere, die niemand geprueft hat. Sind Texte eines Tages
   *   nirgends mehr vorgesehen und auch keine mehr vorhanden, soll „Alles"
   *   keinen Knopf „Texte" anbieten, der auf eine leere Liste fuehrt.
   *   Warum nicht leer, wie es bis zum 07.10.2026 war? Weil Marcel
   *   ausdruecklich das Gegenteil verlangt hat: „Bitte ueberall Filter mit
   *   Video/Foto hinzunehmen." Auf „Alles" ist der Art-Filter ausserdem der
   *   nuetzlichste von allen — er ist der einzige Weg, eine Caption zu finden,
   *   ohne zu wissen, in welchem Bereich sie liegt.
   *   Und die Vereinigung ist in der Praxis genau der volle Vorrat, solange es
   *   irgendwo Texte gibt. Der Unterschied zeigt sich nur in dem Fall, in dem
   *   die Behauptung falsch waere.
   *
   * RUECKFALL: faellt /struktur aus (der Fehler wird dort bewusst
   * verschluckt, damit die Liste trotzdem laedt), gibt es keine Bereiche und
   * damit keine Vereinigung. Dann gilt der Wertevorrat aus /struktur und
   * zuletzt CH_ARTEN — ohne ihn waere die Art-Leiste ueberall weg, und genau
   * das war Marcels Beschwerde vom 08.10.
   */
  function chArtenFuer(struktur, bereichId) {
    const s = struktur || {};
    const vorrat = (s.medientypen && s.medientypen.length) ? s.medientypen : CH_ARTEN;
    const bereiche = s.bereiche || [];
    const leer = (bereichId === null || bereichId === undefined || bereichId === '');

    if (!leer) {
      const id = String(bereichId);
      const bereich = bereiche.filter(function (b) {
        return String((b || {}).id) === id;
      })[0];
      const arten = (bereich && bereich.arten) || [];
      // Ein Bereich, den /struktur nicht kennt (oder ein alter Worker ohne das
      // Feld): der Wertevorrat. Geraten wird nicht, und eine leere Leiste
      // waere schlimmer als eine vollstaendige.
      return arten.length ? arten.slice() : vorrat.slice();
    }

    // „Alles": die Vereinigung, in der Folge des Wertevorrats — damit die
    // Leiste ueberall „Fotos, Videos, Texte" liest und nicht einmal so und
    // einmal anders.
    const gesehen = {};
    bereiche.forEach(function (b) {
      ((b || {}).arten || []).forEach(function (t) { gesehen[String(t)] = true; });
    });
    const vereint = vorrat.filter(function (t) { return gesehen[String(t)]; });
    return vereint.length ? vereint : vorrat.slice();
  }

  /**
   * ZEIGT DIE ART-LEISTE UEBERHAUPT?
   *
   * 🔴 BEI GENAU EINER ART NICHT. Ein einzelner Knopf kann nur auf das
   * filtern, was ohnehin schon zu sehen ist — er ist eine Schaltflaeche ohne
   * Wirkung, und am Handy nimmt sie eine Zeile weg, die die Kacheln brauchen.
   *
   * Der Fall, fuer den das gebaut ist, ist „07 Print": dort liegen
   * Druckvorlagen, die technisch alle 'text' sind (eine PDF ist im
   * Wertevorrat des Uploads ein 'text'), und Migration 0031 legt genau diese
   * eine Art fest.
   *
   * ES IST EINE REGEL UEBER DIE ZAHL UND NICHT UEBER DEN NAMEN „PRINT". Das
   * ist der Unterschied zu chIstPrintBereich, und er ist beabsichtigt: haette
   * Marcel morgen einen zweiten Bereich mit nur einer Art, verhielte er sich
   * gleich — und wuerden in Print eines Tages auch Fotos erlaubt, erscheint die
   * Leiste von selbst, ohne dass hier etwas nachgetragen werden muss.
   */
  function chZeigtArtLeiste(arten) {
    return ((arten || []).length > 1);
  }

  /**
   * WELCHE FILTERACHSEN EINE ANSICHT HAT — aus den Daten, nicht aus dem Code.
   *
   * ART: ueberall, auch ohne Bereich. Marcel am 08.10.2026: „Bitte ueberall
   *   Filter mit Video/Foto hinzunehmen." Der Wertevorrat kommt aus /struktur
   *   (medientypen), mit CH_ARTEN als Rueckfall — ohne ihn waere die Leiste bei
   *   einem Ausfall von /struktur ueberall weg. Die Arten werden NICHT danach
   *   gefiltert, was tatsaechlich liegt: dafuer muesste die Struktur je Bereich
   *   zaehlen, und ein Filter, der eine leere Liste ergibt, ist eine ehrlichere
   *   Auskunft als ein Filter, der gar nicht erst erscheint.
   *
   * THEMA: nur mit Bereich — die Tags dieses Bereichs plus die globalen
   *   (bereich_id === null, die gelten ueberall).
   *
   * PRODUKT: nur im Produktbereich (chIstProduktBereich). ⚠️ Bis zum
   *   08.10.2026 stand die Achse in JEDEM Bereich, sobald ueberhaupt ein
   *   Produkt Material trug — denn /struktur nennt je Produkt keinen Bereich.
   *   Marcels Bild zeigte den Produktfilter unter „01 Kampagnen", und genau das
   *   ist weg. Die Einschraenkung passiert hier und NICHT in /struktur: die
   *   Liste der Produkte bleibt global richtig, nur die Leiste zeigt sie
   *   woanders nicht.
   */
  function chAchsen(struktur, bereichId) {
    const s = struktur || {};
    // ⚠️ SEIT DEM 08.10.2026 IST DIE ART-ACHSE BEREICHSABHAENGIG. Bis dahin
    // stand hier `vorrat.slice()` — in JEDER Ansicht alle drei Arten. Marcel:
    // „Texte nur bei Skinmade Sessions und Berater gewinnen." Welche Arten
    // gelten, steht in den DATEN (chArtenFuer liest bereiche[].arten aus
    // /struktur) und nicht hier.
    const arten = chArtenFuer(s, bereichId);
    const leer = (bereichId === null || bereichId === undefined || bereichId === '');
    if (leer) return { themen: [], produkte: [], arten: arten };
    const id = String(bereichId);
    const themen = (s.tags || []).filter(function (t) {
      const b = t && t.bereich_id;
      return b === null || b === undefined || String(b) === id;
    });
    const bereich = (s.bereiche || []).filter(function (b) {
      return String((b || {}).id) === id;
    })[0];
    const produkte = chIstProduktBereich(bereich) ? (s.produkte || []).slice() : [];
    return { themen: themen, produkte: produkte, arten: arten };
  }

  /**
   * ZEIGT DIESE KACHEL IHRE TITELZEILE?
   *
   * Marcel am 08.10.2026, nach dem Durchgang am Handy: „bildtitel nur bei
   * Print anzeigen, sonst brauchen wir es nicht."
   *
   * ⚠️ HIER HAT SICH DIE ANSAGE SCHON ZWEIMAL GEAENDERT, und die juengste
   * gilt. Der Weg, damit niemand die Fassungen durcheinanderbringt:
   *
   *   bis 07.10.  Titelzeile in JEDER Ansicht, immer.
   *   08.10. (1)  „Bei ‚Alles', bitte Titel rausnehmen und Titel nur bei Flyer
   *               behalten" -> auf „Alles" nur bei Druckdateien, erkannt an
   *               der Endung (.pdf/.docx); im Bereich weiter immer.
   *   08.10. (2)  „bildtitel nur bei Print anzeigen, sonst brauchen wir es
   *               nicht" -> NUR noch im Print-Bereich, und zwar auch dort, wo
   *               ein Bereich gewaehlt ist. GILT.
   *
   * 🔴 ENTSCHIEDEN WIRD AM BEREICH DES MEDIUMS UND NICHT AN DER ANSICHT. Jede
   * Zeile aus /api/content/medien traegt bereich_name mit — die Kachel weiss
   * also auch auf „Alles", wo sie liegt. Deshalb braucht diese Funktion die
   * gewaehlte Bereichskennung nicht mehr (sie hatte sie bis zum 08.10. als
   * zweiten Parameter), und die Antwort ist fuer dasselbe Medium ueberall
   * dieselbe: in „07 Print" steht der Titel, in der Uebersicht „Alles" steht
   * er bei derselben Kachel ebenfalls. Eine Kachel, die in zwei Ansichten
   * anders aussieht, war die Schwaeche der vorigen Fassung.
   *
   * 🔴 UND WARUM NICHT MEHR AN DER ENDUNG (.pdf/.docx)? Weil Marcels neue
   * Ansage eine andere Frage stellt. Die Endung sagt etwas ueber die DATEI;
   * „Print" ist ein ORT. Eine Preisliste als PDF in „02 Unternehmen" ist keine
   * Druckvorlage und soll keine Titelzeile bekommen — unter der alten Regel
   * bekam sie eine. Beide Regeln nebeneinander waeren zwei Antworten auf
   * dieselbe Frage.
   *
   * Wie „Print" erkannt wird — am NAMEN, nicht an „07" und nicht an einer ID —
   * steht bei chIstPrintBereich.
   *
   * 🔴 WO DIE ZEILE WEGFAELLT, IST DER TITEL NICHT WEG, SONDERN LEISER. Er
   * bleibt auf drei Wegen erreichbar, und keiner davon braucht eine Maus (das
   * Dashboard wird ueberwiegend am Handy benutzt; Marcels Bild ist ein
   * iPhone-Screenshot):
   *
   *   1. EIN TIPP AUF DAS BILD holt ihn hervor (.sm-ch-card__bildtitel, siehe
   *      karteHtml). Ein reiner Mauszeiger-Effekt waere fuer 150 Beraterinnen
   *      kein versteckter Titel, sondern keiner.
   *   2. VORLESEN: die Kachel traegt den Titel als aria-label, und jeder
   *      Knopf heisst „Herunterladen: <Titel>". Wer mit VoiceOver oder
   *      TalkBack arbeitet, hoert ihn, ohne irgendetwas aufklappen zu muessen.
   *   3. BEIM HERUNTERLADEN: die signierte Adresse traegt den
   *      ORIGINALDATEINAMEN (content-disposition, im Worker gesetzt) — die
   *      Datei liegt also unter einem Namen auf dem Telefon und nicht als
   *      a7f3c9.mp4.
   */
  function chZeigtTitel(medium) {
    return chIstPrintBereich({ name: (medium || {}).bereich_name });
  }

  /**
   * LAESST SICH DIESES MEDIUM IM FENSTER ANSEHEN?
   *
   * Marcel am 08.10.2026: „Man möchte quasi eine Vorschau sowohl vom Foto als
   * auch vom Video."
   *
   * 🔴 GEFRAGT WIRD DER WORKER, NICHT DER MEDIENTYP. vorschau_pfad steht in
   * der Antwort von /api/content/medien genau dann, wenn es etwas anzuzeigen
   * gibt: Typ foto oder video UND eine Datei dahinter (ein eingetippter Text
   * hat keine). Die Oberflaeche liest das ab und entscheidet es nicht neu.
   *
   * Warum nicht `medientyp === 'foto' || medientyp === 'video'`? Das waere eine
   * zweite Liste neben VORSCHAU_TYPEN im Worker — und zwei Listen laufen
   * auseinander. Genau diese Falle steht im Kopf von Migration 0022, und
   * genau sie hat am 08.10.2026 schon einmal zugeschlagen: 'print' war im
   * Admin noch eine Art, im Worker nicht mehr, und jede PDF wurde abgewiesen.
   *
   * ⚠️ UND ES IST DER SICHERE RUECKFALL. Laeuft eine Theme-Fassung gegen einen
   * aelteren Worker, der das Feld nicht kennt, ist die Antwort hier false: die
   * Kachel bleibt beim Titel-Tipp vom 07.10. und bietet keine Vorschau an, die
   * in einen 404 laufen wuerde. Ein geratener Pfad ('/api/content/vorschau/' +
   * id) waere hier das Gegenteil — eine Oberflaeche, die Adressen erfindet.
   */
  function chHatVorschau(medium) {
    const pfad = (medium || {}).vorschau_pfad;
    return typeof pfad === 'string' && pfad.trim() !== '';
  }

  /** Die Beschriftung einer Art. Mehrzahl, weil der Chip eine Menge filtert. */
  function chArtLabel(typ) {
    const t = String(typ || '');
    if (t === 'foto') return i18n('dashboard.contentHub.art.fotos');
    if (t === 'video') return i18n('dashboard.contentHub.art.videos');
    if (t === 'text') return i18n('dashboard.contentHub.art.texte');
    return t || '—';
  }

  // Der Abfrageteil fuer /api/content/medien. OHNE gesetzte Werte ist er LEER —
  // genau das ist die Einstiegsseite („es duerfen keine Filter hinterlegt sein").
  // 'typ' kam am 07.10.2026 dazu, auf Marcels Wunsch.
  // `rolle` kam am 09.10.2026 dazu (Migration 0032: ein Kosmetikstudio sieht
  // „06 Berater Gewinn(en)" nicht).
  //
  // 🔴 ALS ZWEITES ARGUMENT UND NICHT AUS DER MODULVARIABLEN ROLLE. Diese
  // Funktion ist eine der reinen Helfer, die der Standalone-Test ohne DOM und
  // ohne Netz prueft (contenthub.test.mjs). Griffe sie auf ROLLE zu, haette
  // sie einen versteckten Eingang, und der Test muesste erst einen Zustand
  // herstellen, um eine Zeichenkette zu pruefen.
  //
  // 🔴 'berater' HAENGT NICHTS AN. Der Worker behandelt einen fehlenden
  // Parameter genau wie 'berater' (leseRolle), die Adresse waere also nur
  // laenger. Wichtiger: damit ist JEDE Adresse, die das Berater-Dashboard
  // stellt, buchstaeblich dieselbe wie vor dem Umbau — und das ist die
  // Zusicherung, die dieser Umbau braucht, weil er kurz vor dem Live-Gang
  // kommt. Umgekehrt ist eine Adresse MIT ?rolle=studio in den Entwicklerwerk-
  // zeugen sofort als die des Studio-Dashboards zu erkennen.
  function chAbfrage(filter, rolle) {
    const f = filter || {};
    const teile = [];
    if (f.bereich) teile.push('bereich=' + encodeURIComponent(f.bereich));
    if (f.typ) teile.push('typ=' + encodeURIComponent(f.typ));
    if (f.tag) teile.push('tag=' + encodeURIComponent(f.tag));
    if (f.produkt) teile.push('produkt=' + encodeURIComponent(f.produkt));
    if (String(rolle || '') === 'studio') teile.push('rolle=studio');
    return teile.length ? '?' + teile.join('&') : '';
  }

  // Die Zeile unter der Filterleiste. Gibt die Hinweise des Servers WEITER und
  // verschluckt sie nicht: ohne „vorschau_warnung" ist eine Uebersicht voller
  // Platzhaltersymbole ein Raetsel. Eine leere Liste bekommt keinen Text —
  // dafuer ist der Leerzustand da.
  function chListenNote(daten) {
    const d = daten || {};
    const teile = [];
    const anzahl = Number(d.anzahl);
    if (Number.isFinite(anzahl) && anzahl > 0) {
      teile.push(anzahl === 1 ? i18n('dashboard.contentHub.liste.eineDatei') : i18n('dashboard.contentHub.liste.dateien', { n: anzahl }));
    }
    if (d.hinweis) teile.push(String(d.hinweis));
    if (d.vorschau_warnung) teile.push(String(d.vorschau_warnung));
    return teile.join(' · ');
  }

  // Fortschritt beim Holen der Datei. Ohne bekannte Gesamtgroesse keine
  // erfundene Prozentzahl — dann nur, was schon da ist.
  function chFortschrittText(geladen, gesamt) {
    // null heisst „noch nichts gemessen" und nicht 0 — Number(null) ist 0, und
    // „0 % von 136 MB" waere eine Messung, die nicht stattgefunden hat.
    if (geladen === null || geladen === undefined || geladen === '') return i18n('dashboard.contentHub.aktion.wirdVorbereitet');
    const g = Number(geladen);
    const t = Number(gesamt);
    if (!Number.isFinite(g) || g < 0) return i18n('dashboard.contentHub.aktion.wirdVorbereitet');
    if (!Number.isFinite(t) || t <= 0) return i18n('dashboard.contentHub.fortschritt.geladen', { groesse: chBytes(g) });
    const pct = Math.min(100, Math.round((g / t) * 100));
    return i18n('dashboard.contentHub.fortschritt.prozent', { pct: pct, geladen: chBytes(g), gesamt: chBytes(t) });
  }

  function chFortschrittProzent(geladen, gesamt) {
    if (geladen === null || geladen === undefined || geladen === '') return null;
    const g = Number(geladen);
    const t = Number(gesamt);
    if (!Number.isFinite(g) || !Number.isFinite(t) || t <= 0) return null;
    return Math.max(0, Math.min(100, Math.round((g / t) * 100)));
  }

  // Der Leerzustand sagt etwas ANDERES, je nachdem, ob ein Filter steht: „es
  // gibt nichts" und „zu dieser Auswahl gibt es nichts" sind zwei Lagen, und
  // nur bei der zweiten hilft ein Zuruecksetzen.
  function chLeerText(filter) {
    const f = filter || {};
    // 'typ' zaehlt seit dem 08.10.2026 mit: der Art-Filter steht nun auch auf
    // „Alles", und „Videos" ohne ein einziges Video ist genau die Lage, in der
    // ein Zuruecksetzen hilft. Ohne ihn stuende dort „Hier ist noch kein
    // Material hinterlegt" — eine Aussage ueber den ganzen Hub, wo es nur eine
    // ueber die Auswahl ist.
    if (f.typ || f.tag || f.produkt) {
      return {
        titel: i18n('dashboard.contentHub.leer.auswahlTitel'),
        text: f.bereich
          ? i18n('dashboard.contentHub.leer.auswahlBereich')
          : i18n('dashboard.contentHub.leer.auswahlAlles'),
        reset: true,
      };
    }
    if (f.bereich) {
      return {
        titel: i18n('dashboard.contentHub.leer.bereichTitel'),
        text: i18n('dashboard.contentHub.leer.bereichText'),
        reset: false,
      };
    }
    return {
      titel: i18n('dashboard.contentHub.leer.titel'),
      text: i18n('dashboard.contentHub.leer.text'),
      reset: false,
    };
  }

  // --- Nicht ganz rein: fragt den Browser ------------------------------------

  // KANN DIESER BROWSER DATEIEN TEILEN? Geprueft mit einer winzigen Probedatei
  // und canShare — nicht an der Bildschirmbreite (siehe Kopf). Alles in einem
  // try: in einem Kontext ohne File/Blob (und im Test) darf das nicht werfen.
  function chBrowserKannDateienTeilen() {
    try {
      if (typeof navigator === 'undefined' || typeof navigator.canShare !== 'function') return false;
      if (typeof navigator.share !== 'function') return false;
      if (typeof File === 'undefined' || typeof Blob === 'undefined') return false;
      const probe = new File(
        [new Blob([new Uint8Array(1)], { type: 'image/png' })],
        'probe.png',
        { type: 'image/png' },
      );
      return !!navigator.canShare({ files: [probe] });
    } catch (e) {
      return false;
    }
  }

  // --- Die Oberflaeche --------------------------------------------------------

  function initContentHub(pane) {
    const bereicheEl   = pane.querySelector('[data-sm-ch-bereiche]');
    const filterEl     = pane.querySelector('[data-sm-ch-filter]');
    const artBlock     = pane.querySelector('[data-sm-ch-art-block]');
    const artenEl      = pane.querySelector('[data-sm-ch-arten]');
    const produktBlock = pane.querySelector('[data-sm-ch-produkt-block]');
    const produktSel   = pane.querySelector('[data-sm-ch-produkt]');
    const themenBlock  = pane.querySelector('[data-sm-ch-themen-block]');
    const themenEl     = pane.querySelector('[data-sm-ch-themen]');
    const resetBtn     = pane.querySelector('[data-sm-ch-reset]');
    const noteEl       = pane.querySelector('[data-sm-ch-note]');
    const loadingEl    = pane.querySelector('[data-sm-ch-loading]');
    const errorEl      = pane.querySelector('[data-sm-ch-error]');
    const emptyEl      = pane.querySelector('[data-sm-ch-empty]');
    const emptyTitle   = pane.querySelector('[data-sm-ch-empty-title]');
    const emptyText    = pane.querySelector('[data-sm-ch-empty-text]');
    const gridEl       = pane.querySelector('[data-sm-ch-grid]');
    if (!gridEl) return;

    const textModal  = pane.querySelector('[data-sm-ch-textmodal]');
    const textTitle  = pane.querySelector('[data-sm-ch-text-title]');
    const textMeta   = pane.querySelector('[data-sm-ch-text-meta]');
    const textBody   = pane.querySelector('[data-sm-ch-text-body]');
    const textHint   = pane.querySelector('[data-sm-ch-text-hint]');
    const textError  = pane.querySelector('[data-sm-ch-text-error]');
    const textCopy   = pane.querySelector('[data-sm-ch-text-copy]');

    // Das Vorschaufenster (08.10.2026). vorPanel ist das WURZELELEMENT fuer
    // kartenFehler() und fortschritt() — es traegt dieselben data-Attribute wie
    // eine Kachel, siehe Markup im Snippet.
    const vorModal    = pane.querySelector('[data-sm-ch-vorschau]');
    const vorPanel    = pane.querySelector('[data-sm-ch-vorschau] .sm-ch-modal__panel');
    const vorTitel    = pane.querySelector('[data-sm-ch-vorschau-titel]');
    const vorMeta     = pane.querySelector('[data-sm-ch-vorschau-meta]');
    const vorSpinner  = pane.querySelector('[data-sm-ch-vorschau-spinner]');
    const vorBild     = pane.querySelector('[data-sm-ch-vorschau-bild]');
    const vorVideo    = pane.querySelector('[data-sm-ch-vorschau-video]');
    const vorAktionen = pane.querySelector('[data-sm-ch-vorschau-aktionen]');

    const kannTeilen = chBrowserKannDateienTeilen();

    let struktur = { bereiche: [], tags: [], produkte: [], medientypen: [] };
    let medien = [];
    let filter = { bereich: null, typ: null, tag: null, produkt: null };
    // Einplatz-Zwischenlager fuer die zuletzt geholte Datei — damit der zweite
    // Tipp („Jetzt teilen") sie nicht erneut laedt. Genau EIN Platz: dort
    // liegen bis zu 500 MB.
    let lager = null;
    // Der Text des gerade geoeffneten Mediums, damit „Text kopieren" im Dialog
    // ihn nicht erneut holt.
    let offenerText = '';

    function zeige(el, an) { if (el) el.hidden = !an; }

    async function chFetch(pfad) {
      const antwort = await fetch(PROVISION_WORKER_BASE + pfad, { headers: { Accept: 'application/json' } });
      let daten = null;
      try { daten = await antwort.json(); } catch (e) { daten = null; }
      if (!antwort.ok || !daten || daten.ok === false) {
        const grund = (daten && (daten.error || daten.fehler)) || ('HTTP ' + antwort.status);
        throw new Error(String(grund));
      }
      return daten;
    }

    // ---- Bereichsleiste ----
    function renderBereiche() {
      if (!bereicheEl) return;
      const allesAktiv = !filter.bereich;
      const alles = '<button type="button" class="sm-chip sm-ch-bereich"'
        + (allesAktiv ? ' data-active' : '')
        + ' aria-pressed="' + (allesAktiv ? 'true' : 'false') + '"'
        + ' data-sm-ch-bereich="">' + i18n('dashboard.contentHub.bereich.alles') + '</button>';
      const rest = (struktur.bereiche || []).map(function (b) {
        const aktiv = String(filter.bereich || '') === String(b.id);
        const anzahl = Number(b.medien_anzahl);
        const zahl = Number.isFinite(anzahl)
          ? '<span class="sm-chip__count">' + anzahl + '</span>'
          : '';
        return '<button type="button" class="sm-chip sm-ch-bereich"'
          + (aktiv ? ' data-active' : '')
          + ' aria-pressed="' + (aktiv ? 'true' : 'false') + '"'
          + ' data-sm-ch-bereich="' + escape(String(b.id)) + '">'
          + escape(chBereichLabel(b)) + zahl + '</button>';
      }).join('');
      bereicheEl.innerHTML = alles + rest;
      bereicheEl.querySelectorAll('[data-sm-ch-bereich]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const wert = btn.getAttribute('data-sm-ch-bereich');
          // Bereichswechsel wirft die Unterfilter weg — ein Thema aus dem
          // alten Bereich gibt es im neuen nicht.
          filter = { bereich: wert || null, typ: null, tag: null, produkt: null };
          renderBereiche();
          renderFilter();
          ladeMedien();
        });
      });
    }

    // ---- Filterleiste (bereichsabhaengig, aus den Daten) ----
    function renderFilter() {
      const achsen = chAchsen(struktur, filter.bereich);
      const hatThemen = achsen.themen.length > 0;
      const hatProdukte = achsen.produkte.length > 0;
      // 🔴 NICHT `> 0`: eine Leiste mit EINEM Knopf kann nur auf das filtern,
      // was ohnehin zu sehen ist. Begruendung bei chZeigtArtLeiste — der Fall,
      // fuer den das gebaut ist, ist „07 Print" mit seiner einen Art 'text'.
      const hatArten = chZeigtArtLeiste(achsen.arten);

      zeige(artBlock, hatArten);
      zeige(themenBlock, hatThemen);
      zeige(produktBlock, hatProdukte);
      zeige(resetBtn, !!(filter.typ || filter.tag || filter.produkt));
      zeige(filterEl, hatArten || hatThemen || hatProdukte);

      if (hatArten && artenEl) {
        artenEl.innerHTML = achsen.arten.map(function (t) {
          const aktiv = String(filter.typ || '') === String(t);
          return '<button type="button" class="sm-chip"'
            + (aktiv ? ' data-active' : '')
            + ' aria-pressed="' + (aktiv ? 'true' : 'false') + '"'
            + ' data-sm-ch-art="' + escape(String(t)) + '">'
            + escape(chArtLabel(t)) + '</button>';
        }).join('');
        artenEl.querySelectorAll('[data-sm-ch-art]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            const wert = btn.getAttribute('data-sm-ch-art');
            // Nochmal tippen hebt die Wahl auf — wie bei den Themen.
            filter.typ = (String(filter.typ || '') === String(wert)) ? null : wert;
            renderFilter();
            ladeMedien();
          });
        });
      }

      if (hatThemen && themenEl) {
        themenEl.innerHTML = achsen.themen.map(function (t) {
          const aktiv = String(filter.tag || '') === String(t.id);
          return '<button type="button" class="sm-chip"'
            + (aktiv ? ' data-active' : '')
            + ' aria-pressed="' + (aktiv ? 'true' : 'false') + '"'
            + ' data-sm-ch-thema="' + escape(String(t.id)) + '">'
            + escape(String(inhalt(t.name, t.name_en) || '—')) + '</button>';
        }).join('');
        themenEl.querySelectorAll('[data-sm-ch-thema]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            const wert = btn.getAttribute('data-sm-ch-thema');
            // Nochmal tippen hebt die Wahl auf — am Handy der schnellste Weg
            // zurueck.
            filter.tag = (String(filter.tag || '') === String(wert)) ? null : wert;
            renderFilter();
            ladeMedien();
          });
        });
      }

      if (hatProdukte && produktSel) {
        const vorher = filter.produkt ? String(filter.produkt) : '';
        produktSel.innerHTML = '<option value="">' + i18n('dashboard.contentHub.filter.alleProdukte') + '</option>'
          + achsen.produkte.map(function (p) {
            // im_shop = 0 heisst: im Shop verschwunden, das Material lebt
            // weiter (Migration 0027). Gekennzeichnet, nicht weggelassen.
            const zusatz = (p.im_shop === 0 || p.im_shop === false) ? ' (' + i18n('dashboard.contentHub.filter.nichtMehrImShop') + ')' : '';
            return '<option value="' + escape(String(p.shopify_id)) + '">'
              + escape(String(p.titel || p.handle || p.shopify_id) + zusatz) + '</option>';
          }).join('');
        produktSel.value = vorher;
      }
    }

    if (produktSel) {
      produktSel.addEventListener('change', function () {
        filter.produkt = produktSel.value || null;
        zeige(resetBtn, !!(filter.typ || filter.tag || filter.produkt));
        ladeMedien();
      });
    }
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        filter.typ = null;
        filter.tag = null;
        filter.produkt = null;
        renderFilter();
        ladeMedien();
      });
    }

    // ---- Kacheln ----
    function karteHtml(m) {
      const id = escape(String(m.id));
      const typ = String(m.medientyp || '');
      // loading="lazy": bei 150 Kacheln sonst 150 Abrufe gleichzeitig. Die
      // ORIGINALDATEI wird erst beim Tippen geholt — in der Liste steht nur
      // das rund 30 kB grosse Vorschaubild.
      const bild = m.vorschau_url
        ? '<img src="' + escape(m.vorschau_url) + '" alt="" loading="lazy" decoding="async">'
        : '<span class="sm-ch-card__platz" aria-hidden="true">'
          + chPlatzhalter(typ, chHatInhalt(m)) + '</span>';
      const meta = [
        chBereichLabel({ nummer: m.bereich_nummer, name: m.bereich_name, name_en: m.bereich_name_en }),
        chTypLabel(typ),
        chBytes(m.groesse_bytes),
      ].join(' · ');
      const titelText = String(inhalt(m.titel, m.titel_en) || m.dateiname || '—');
      const knoepfe = chAktionen(m, kannTeilen).map(function (a) {
        const stil = a.haupt ? 'sm-btn sm-btn-primary' : 'sm-btn sm-btn-ghost';
        // 🔴 DER KNOPF NENNT DEN TITEL IM aria-label. Seit Marcels Ansage vom
        // 08.10.2026 steht die Titelzeile nur noch bei Print — ohne diesen
        // Zusatz hoerte jemand mit VoiceOver in einer Liste von zwanzig
        // Kacheln zwanzigmal „Herunterladen" und wuesste nie, was.
        // Die sichtbare Beschriftung bleibt kurz: auf einem 150-px-Knopf passt
        // kein Titel, und der Platz gehoert der Handlung.
        return '<button type="button" class="' + stil + ' sm-ch-card__btn"'
          + ' aria-label="' + escape(a.label + ': ' + titelText) + '"'
          + ' data-sm-ch-aktion="' + escape(a.art) + '" data-sm-ch-id="' + id + '">'
          + escape(a.label) + '</button>';
      }).join('');

      // ===================================================================
      // 🔴 DER TITEL — SICHTBAR NUR BEI PRINT, ERREICHBAR UEBERALL
      // ===================================================================
      // Marcel: „bildtitel nur bei Print anzeigen, sonst brauchen wir es
      // nicht." Die Regel steht in chZeigtTitel, hier steht ihre Folge:
      //
      //   PRINT      die laute Zeile im Kachelkoerper. In einer Liste von vier
      //              Flyern ist der Name die einzige Unterscheidung — unter
      //              einem 📄 sehen sie alle gleich aus.
      //   SONST      keine sichtbare Zeile. Aber auch nicht verschwunden:
      //              das Bild wird zu einem Knopf, der den Titel klein
      //              darueber legt (.sm-ch-card__bildtitel), und er steht als
      //              aria-label an der Kachel und an jedem Knopf.
      //
      // ⚠️ KEIN HOVER UND KEIN title-ATTRIBUT als einziger Weg. Am Handy gibt
      // es weder das eine noch das andere; ein Titel, den nur eine Maus
      // hervorholt, ist fuer 150 Beraterinnen keiner. Der Tipp auf das Bild
      // funktioniert mit dem Finger, mit der Maus und mit der Tastatur.
      const zeigtTitel = chZeigtTitel(m);

      // ===================================================================
      // 🔴 WAS EIN TIPP AUF DAS BILD TUT — DREI FAELLE, EINE FLAECHE
      // ===================================================================
      // Marcel am 08.10.2026: „Dass man sich die Bilder öffnen kann [...] man
      // möchte quasi eine Vorschau sowohl vom Foto als auch vom Video."
      //
      //   FOTO/VIDEO   VORSCHAU. Das Bild oeffnet das Fenster, der Titel steht
      //                dort gross drin. Der Titel-Tipp vom 07.10. ist hier
      //                ABGELOEST und nicht daneben: eine Flaeche kann nur eine
      //                Handlung haben. Zwei Bedeutungen auf demselben Tipp
      //                waeren am Finger ein Raten, und die Vorschau ist die
      //                staerkere — sie zeigt den Titel mit.
      //   PRINT        NICHTS. Die Titelzeile steht ohnehin im Kachelkoerper
      //                (chZeigtTitel), und eine PDF hat keine Vorschau: ein
      //                Browser-Betrachter im <iframe> ist auf iOS
      //                unzuverlaessig, und ein leeres Fenster ist schlimmer
      //                als kein Fenster.
      //   SONST        TITEL-TIPP wie bisher. Das ist der Rueckfall fuer alles,
      //                was weder Print ist noch eine Vorschau hat — eine PDF
      //                in „02 Unternehmen" etwa, oder jede Kachel, solange ein
      //                aelterer Worker vorschau_pfad nicht mitliefert.
      const hatVorschau = chHatVorschau(m);
      // Das Bild bleibt mit alt="" dekorativ — der Titel steht am Knopf, und
      // zweimal derselbe Text hintereinander vorgelesen ist eine Zumutung.
      let bildFlaeche;
      if (zeigtTitel) {
        bildFlaeche = '<div class="sm-ch-card__bild">' + bild + '</div>';
      } else if (hatVorschau) {
        // Die Beschriftung nennt die HANDLUNG und den Titel: wer mit VoiceOver
        // durch zwanzig Kacheln geht, hoert „Vorschau öffnen: Sommerfoto 3"
        // und nicht zwanzigmal dasselbe. is-vorschau macht aus dem Zeiger eine
        // Lupe — ein Knopf, der aussieht wie ein Bild, braucht das Zeichen.
        bildFlaeche = '<div class="sm-ch-card__bild">'
          + '<button type="button" class="sm-ch-card__bildflaeche is-vorschau"'
          + ' data-sm-ch-vorschau-oeffnen'
          + ' aria-label="' + escape(i18n('dashboard.contentHub.karte.vorschauOeffnen', { titel: titelText })) + '">'
          + bild
          + '<span class="sm-ch-card__lupe" aria-hidden="true">'
          + (typ === 'video' ? '▶' : '⤢') + '</span>'
          + '</button>'
          + '</div>';
      } else {
        bildFlaeche = '<div class="sm-ch-card__bild">'
          + '<button type="button" class="sm-ch-card__bildflaeche"'
          + ' data-sm-ch-titel aria-expanded="false"'
          + ' aria-label="' + escape(i18n('dashboard.contentHub.karte.titelAnzeigen', { titel: titelText })) + '">'
          + bild + '</button>'
          // hidden und nicht per CSS verborgen: so ist der Titel im DOM, wird
          // von Hilfsmitteln aber nicht doppelt vorgelesen, solange er zu ist.
          + '<span class="sm-ch-card__bildtitel" data-sm-ch-bildtitel hidden>'
          + escape(titelText) + '</span>'
          + '</div>';
      }

      return '<article class="sm-ch-card" data-sm-ch-card="' + id + '"'
        + ' aria-label="' + escape(titelText) + '">'
        + bildFlaeche
        + '<div class="sm-ch-card__body">'
        + (zeigtTitel
          ? '<strong class="sm-ch-card__titel" title="' + escape(String(m.dateiname || '')) + '">'
            + escape(titelText) + '</strong>'
          : '')
        + '<span class="sm-ch-card__meta">' + escape(meta) + '</span>'
        + '</div>'
        + '<div class="sm-ch-card__fort" data-sm-ch-fort hidden>'
        // Kein style="width:0%" mehr: der Balken fuellt sich ueber scaleX, und
        // seinen Anfangszustand (scaleX(0)) setzt das Stilblatt. Eine Breite im
        // Markup waere der Rest des alten Verfahrens und wuerde die 100 %
        // ueberschreiben, die scaleX staucht — der Balken blieb unsichtbar.
        + '<div class="sm-ch-card__bar"><span data-sm-ch-bar></span></div>'
        + '<span class="sm-ch-card__fort-text" data-sm-ch-fort-text></span>'
        + '</div>'
        + '<p class="sm-ch-card__fehler" data-sm-ch-cardfehler hidden role="alert"></p>'
        + '<div class="sm-ch-card__actions">' + knoepfe + '</div>'
        + '</article>';
    }

    function renderMedien() {
      gridEl.innerHTML = medien.map(karteHtml).join('');

      // 🔴 EIN TIPP AUF DAS BILD HOLT DEN TITEL HERVOR — und ein zweiter legt
      // ihn wieder weg. Das ist der sichtbare Weg zum Titel, seit er ausserhalb
      // von Print keine eigene Zeile mehr hat (Marcel 08.10.2026).
      //
      // Warum ein <button> und nicht ein Klickempfaenger auf dem <div>: nur ein
      // Knopf ist mit der Tastatur erreichbar, wird als bedienbar vorgelesen
      // und hat ein aria-expanded, das seinen Zustand mitteilt. Ein klickbares
      // <div> ist am Finger dasselbe und fuer alles andere nichts.
      //
      // Die Beschriftung wandert mit dem Zustand („Titel anzeigen" ->
      // „Titel verbergen"): ein Knopf, der nach dem Tippen dasselbe behauptet,
      // ist beim zweiten Tipp eine Ueberraschung.
      gridEl.querySelectorAll('[data-sm-ch-titel]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const karte = btn.closest('[data-sm-ch-card]');
          const titel = karte && karte.querySelector('[data-sm-ch-bildtitel]');
          if (!titel) return;
          const offen = titel.hidden;
          titel.hidden = !offen;
          btn.setAttribute('aria-expanded', offen ? 'true' : 'false');
          const name = titel.textContent || '';
          btn.setAttribute('aria-label', offen ? i18n('dashboard.contentHub.karte.titelVerbergen', { titel: name }) : i18n('dashboard.contentHub.karte.titelAnzeigen', { titel: name }));
        });
      });

      // DER TIPP AUF DAS BILD BEI FOTO UND VIDEO — oeffnet das Vorschaufenster
      // (Marcel 08.10.2026). Welche Kachel diesen Knopf traegt und welche
      // stattdessen beim Titel-Tipp bleibt, entscheidet karteHtml; hier wird
      // nur verdrahtet, was da ist.
      gridEl.querySelectorAll('[data-sm-ch-vorschau-oeffnen]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const karte = btn.closest('[data-sm-ch-card]');
          const id = karte && karte.getAttribute('data-sm-ch-card');
          const m = medien.find(function (x) { return String(x.id) === String(id); });
          if (!m) return;
          oeffneVorschau(m, btn);
        });
      });

      gridEl.querySelectorAll('[data-sm-ch-aktion]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          const id = btn.getAttribute('data-sm-ch-id');
          const m = medien.find(function (x) { return String(x.id) === String(id); });
          if (!m) return;
          const karte = btn.closest('[data-sm-ch-card]');
          const art = btn.getAttribute('data-sm-ch-aktion');
          if (art === 'teilen') return teileMedium(m, karte, btn);
          if (art === 'textkopieren') return kopiereText(m, karte, btn);
          if (art === 'textzeigen') return zeigeText(m, karte);
          return ladeHerunter(m, karte, btn);
        });
      });
    }

    // Die Zeile unter der Kachel. `nurHinweis` macht daraus eine ruhige
    // Mitteilung statt einer Fehlermeldung: „Die Datei ist bereit, tippe noch
    // einmal" ist auf dem iPhone der NORMALE Weg bei grossen Videos (die
    // Nutzergeste ist nach dem Laden verbraucht) und darf nicht rot aussehen.
    function kartenFehler(karte, text, nurHinweis) {
      if (!karte) return;
      const el = karte.querySelector('[data-sm-ch-cardfehler]');
      if (!el) return;
      if (!text) { el.hidden = true; el.textContent = ''; el.className = 'sm-ch-card__fehler'; return; }
      el.hidden = false;
      el.className = nurHinweis ? 'sm-ch-card__fehler is-hinweis' : 'sm-ch-card__fehler';
      el.textContent = text;
    }

    function fortschritt(karte, geladen, gesamt) {
      if (!karte) return;
      const box = karte.querySelector('[data-sm-ch-fort]');
      const bar = karte.querySelector('[data-sm-ch-bar]');
      const txt = karte.querySelector('[data-sm-ch-fort-text]');
      if (!box) return;
      if (geladen === null) { box.hidden = true; return; }
      box.hidden = false;
      const pct = chFortschrittProzent(geladen, gesamt);
      if (bar) {
        // 🔴 GESETZT WIRD scaleX, NICHT width. Diese Funktion laeuft bei einem
        // 500-MB-Video viermal je Sekunde ueber Minuten; eine Breitenaenderung
        // zwingt den Browser jedes Mal zu Layout und Neuzeichnen, scaleX laeuft
        // auf der Grafikkarte. Dasselbe Verfahren wie beim Upload-Fortschritt
        // im Admin (admin-dashboard.js, 08.10.2026); das CSS traegt dazu
        // transform-origin: left und width: 100%.
        //
        // Die Klasse zuerst, der transform danach: im unbestimmten Fall
        // schreibt die Wander-Animation auf dieselbe Eigenschaft, und ein hier
        // gesetzter Wert waere ein zweiter Schreiber. removeProperty raeumt ihn
        // weg, statt sich auf den Vorrang der Animation zu verlassen.
        bar.className = (pct === null ? 'is-unbestimmt' : '');
        if (pct === null) bar.style.removeProperty('transform');
        else bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, pct / 100)) + ')';
      }
      if (txt) txt.textContent = chFortschrittText(geladen, gesamt);
    }

    // ---- Signierte Adresse ----
    async function holeAdresse(medium) {
      const daten = await chFetch('/api/content/download/' + encodeURIComponent(medium.id));
      if (!daten || !daten.url) throw new Error(i18n('dashboard.contentHub.fehler.keineDownloadAdresse'));
      return daten;
    }

    // ---- Herunterladen ----
    // Die signierte Adresse traegt response-content-disposition: attachment mit
    // dem ORIGINALDATEINAMEN. Ein Klick auf einen Anker reicht deshalb; ein
    // download-Attribut waere wirkungslos (fremde Herkunft) und ist weggelassen,
    // damit niemand glaubt, es tue etwas.
    async function ladeHerunter(medium, karte, btn) {
      kartenFehler(karte, '');
      const vorher = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = i18n('dashboard.contentHub.aktion.wirdGeholt'); }
      try {
        const adresse = await holeAdresse(medium);
        const a = document.createElement('a');
        a.href = adresse.url;
        a.rel = 'noopener';
        document.body.appendChild(a);
        a.click();
        a.remove();
      } catch (e) {
        kartenFehler(karte, i18n('dashboard.contentHub.fehler.download', { fehler: (e.message || e) }));
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = vorher; }
      }
    }

    // ---- Datei holen (mit Fortschritt) ----
    async function holeDatei(medium, karte) {
      const adresse = await holeAdresse(medium);
      const antwort = await fetch(adresse.url);
      if (!antwort.ok) throw new Error(i18n('dashboard.contentHub.fehler.dateiKamNicht', { status: antwort.status }));
      const kopfLaenge = Number(antwort.headers.get('Content-Length'));
      const gesamt = Number.isFinite(kopfLaenge) && kopfLaenge > 0
        ? kopfLaenge
        : (Number(medium.groesse_bytes) || 0);

      let blob;
      if (antwort.body && typeof antwort.body.getReader === 'function') {
        // Stueckweise lesen, damit bei einem 130-MB-Video etwas zu sehen ist.
        // fetch kennt keinen Fortschritt, der Strom schon.
        const leser = antwort.body.getReader();
        const stuecke = [];
        let geladen = 0;
        let zuletzt = 0;
        for (;;) {
          /* eslint-disable-next-line no-await-in-loop */
          const schritt = await leser.read();
          if (schritt.done) break;
          stuecke.push(schritt.value);
          geladen += schritt.value.length;
          // Nur rund vier Mal je Sekunde anzeigen. Ein 130-MB-Video kommt in
          // etwa 2.000 Stuecken, und 2.000 Schreibzugriffe auf style.width
          // ruckeln auf dem Telefon mehr, als sie zeigen.
          const jetzt = Date.now();
          if (jetzt - zuletzt > 250) {
            zuletzt = jetzt;
            fortschritt(karte, geladen, gesamt);
          }
        }
        fortschritt(karte, geladen, gesamt);
        blob = new Blob(stuecke, { type: chMimeTyp(medium.dateiname) || antwort.headers.get('Content-Type') || '' });
      } else {
        blob = await antwort.blob();
      }
      const name = String(medium.dateiname || ('skinmade-' + medium.id)).trim() || ('skinmade-' + medium.id);
      return new File([blob], name, { type: blob.type || chMimeTyp(name) });
    }

    // ---- Teilen ----
    // Rueckgabe: 'geteilt' | 'abgebrochen' | 'geste' | 'unmoeglich'
    async function versucheTeilen(datei) {
      try {
        if (typeof navigator.canShare !== 'function' || !navigator.canShare({ files: [datei] })) {
          return 'unmoeglich';
        }
        // ===================================================================
        // 🔴 NUR `files`. KEIN title, KEIN text, KEIN url.
        // ===================================================================
        // Marcel am 10.10.2026: „In den Text vom Bild, den man teilt, kommt
        // der Titel vom Bild. Kann man das noch entfernen, sodass man wirklich
        // nur das Bild teilt?"
        //
        // Ja — und zwar genau hier. Bis dahin stand ein
        //   title: String(medium.titel || '')
        // in diesem Aufruf. WhatsApp (und die meisten Android-Apps) setzen
        // das als BILDUNTERSCHRIFT in die Nachricht; die Beraterin musste sie
        // vor jedem Senden von Hand loeschen. Ein Titel wie „IMG 2437" oder
        // „Vorher nachher Augenärztin" gehoert in den Hub, nicht in die
        // Nachricht an ihre Kundin.
        //
        // ⚠️ WAS DAMIT AUCH WEGFAELLT: bei einer E-Mail-App war der Titel der
        // Betreff, der bleibt jetzt leer. Hingenommen — der Weg, fuer den
        // dieser Knopf gebaut ist, ist WhatsApp/Instagram/TikTok, und dort
        // war der Titel ein Stoerer.
        //
        // ⚠️ DER DATEINAME BLEIBT (siehe holeDatei: new File([blob], name)).
        // Er ist etwas anderes als der Titel: WhatsApp zeigt ihn bei Fotos und
        // Videos nicht an, aber wer das Bild speichert, hat es unter seinem
        // Namen und nicht als a7f3c9-….jpg.
        //
        // ⚠️ UND NIE text/url NACHTRAGEN: das nimmt WhatsApp zum Anlass, die
        // DATEI fallen zu lassen und nur den Text zu schicken. Das war der
        // Grund, warum hier von Anfang an kein text stand.
        //
        // `files` allein ist gueltig — die Spec verlangt mindestens eines der
        // vier Felder, und canShare({ files }) eine Zeile darueber prueft
        // genau diese Form.
        await navigator.share({ files: [datei] });
        return 'geteilt';
      } catch (e) {
        const name = String((e && e.name) || '');
        if (name === 'AbortError') return 'abgebrochen';
        // Safari verlangt eine FRISCHE Nutzergeste — nach dem Laden eines
        // 130-MB-Videos ist die alte verbraucht. Siehe Kopf.
        if (name === 'NotAllowedError' || name === 'SecurityError' || name === 'InvalidStateError') return 'geste';
        throw e;
      }
    }

    function machZuDownload(btn) {
      if (!btn) return;
      btn.setAttribute('data-sm-ch-aktion', 'download');
      btn.className = 'sm-btn sm-btn-primary sm-ch-card__btn';
      btn.textContent = i18n('dashboard.contentHub.aktion.herunterladen');
    }

    async function teileMedium(medium, karte, btn) {
      kartenFehler(karte, '');
      // Liegt die Datei schon im Zwischenlager, ist die Nutzergeste noch
      // frisch — dann OHNE await davor teilen.
      if (lager && String(lager.id) === String(medium.id)) {
        try {
          const wie = await versucheTeilen(lager.file);
          if (wie === 'geteilt' || wie === 'abgebrochen') {
            if (btn) btn.textContent = i18n('dashboard.contentHub.aktion.teilen');
            return;
          }
          if (wie === 'unmoeglich') {
            machZuDownload(btn);
            kartenFehler(karte, i18n('dashboard.contentHub.teilen.geraetKannNicht'));
            return;
          }
        } catch (e) {
          kartenFehler(karte, i18n('dashboard.contentHub.teilen.fehler', { fehler: (e.message || e) }));
          return;
        }
      }

      const vorher = i18n('dashboard.contentHub.aktion.teilen');
      if (btn) { btn.disabled = true; btn.textContent = i18n('dashboard.contentHub.aktion.wirdVorbereitet'); }
      fortschritt(karte, 0, Number(medium.groesse_bytes) || 0);
      try {
        const datei = await holeDatei(medium, karte);
        lager = { id: medium.id, file: datei };
        fortschritt(karte, null);
        const wie = await versucheTeilen(datei);
        if (wie === 'geste') {
          // Datei liegt bereit, nur die Geste fehlt. Der zweite Tipp teilt
          // sofort.
          if (btn) btn.textContent = i18n('dashboard.contentHub.aktion.jetztTeilen');
          kartenFehler(karte, i18n('dashboard.contentHub.teilen.bereit'), true);
          return;
        }
        if (wie === 'unmoeglich') {
          machZuDownload(btn);
          kartenFehler(karte, i18n('dashboard.contentHub.teilen.geraetKannNicht'));
          return;
        }
        if (btn) btn.textContent = vorher;
      } catch (e) {
        // 🔴 Fehlschlag heisst nicht Sackgasse: der Download laeuft ueber eine
        // Navigation und braucht kein CORS, geht also auch dann.
        fortschritt(karte, null);
        kartenFehler(
          karte,
          i18n('dashboard.contentHub.teilen.ladenFehler', { fehler: (e.message || e) }),
        );
        if (btn) btn.textContent = vorher;
      } finally {
        if (btn) btn.disabled = false;
        fortschritt(karte, null);
      }
    }

    // ---- Text lesen und kopieren ----
    // ⚠️ Der Inhalt steht NICHT in /medien (siehe Kopf). ZWEI WEGE, je nachdem,
    // wo er liegt — und die Kachel merkt davon nichts, beide Knoepfe heissen
    // gleich.
    async function holeText(medium) {
      // WEG 1: EINGETIPPTER TEXT (Migration 0030). Eine Anfrage an den Worker,
      // Inhalt aus D1.
      //
      // 🔴 KEIN fetch() gegen R2, also KEINE CORS-Regel am Bucket noetig — der
      // Unterschied, der diesen Weg erst moeglich macht. Und keine
      // Laengenpruefung an der Antwort: der Worker hat den Text beim Anlegen
      // gegen dieselbe 200-kB-Grenze geprueft, es KANN keinen zu langen geben.
      //
      // text_pfad kommt aus der Liste und wird nicht hier zusammengesetzt: so
      // steht der Pfad an einer Stelle (im Worker), und ein spaeterer Umbau
      // zieht die Oberflaeche mit. Der Rueckfall deckt eine Liste ab, die noch
      // von einem alten Worker kommt.
      if (chHatInhalt(medium)) {
        const pfad = medium.text_pfad || ('/api/content/text/' + encodeURIComponent(medium.id));
        const daten = await chFetch(pfad);
        if (daten == null || typeof daten.inhalt !== 'string') {
          throw new Error(i18n('dashboard.contentHub.text.keinText'));
        }
        // 🔴 UNVERAENDERT WEITERGEBEN. Kein trim(), kein replace, kein
        // normalize: was hier zurueckkommt, ist Zeichen fuer Zeichen das, was
        // im Admin eingetippt wurde — mit Absaetzen, Emojis, Hauttoenen,
        // Zero-Width-Joinern und geschuetzten Leerzeichen. Jede Nachbearbeitung
        // hier waere genau die Stelle, an der Marcels Auflage bricht.
        // Englische Fassung, wo gepflegt — ebenso unveraendert (smInhalt prueft
        // nur, ob sie leer ist, und gibt sie sonst Zeichen fuer Zeichen zurueck).
        return inhalt(daten.inhalt, daten.inhalt_en);
      }

      // WEG 2: TEXTDATEI IN R2 (der alte Weg, fuer .txt-Uploads von vor 0030).
      // Erst die signierte Adresse, dann die Datei — und dieser fetch BRAUCHT
      // die CORS-Regel am Bucket.
      const adresse = await holeAdresse(medium);
      const antwort = await fetch(adresse.url);
      if (!antwort.ok) throw new Error(i18n('dashboard.contentHub.text.kamNicht', { status: antwort.status }));
      const laenge = Number(antwort.headers.get('Content-Length'));
      if (Number.isFinite(laenge) && laenge > CH_TEXT_MAX_BYTES) {
        throw new Error(i18n('dashboard.contentHub.text.zuLang'));
      }
      return await antwort.text();
    }

    async function inZwischenablage(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
        return true;
      }
      // Rueckfall fuer Browser ohne Clipboard-API.
      const feld = document.createElement('textarea');
      feld.value = text;
      feld.setAttribute('readonly', '');
      feld.style.position = 'fixed';
      feld.style.left = '-9999px';
      document.body.appendChild(feld);
      feld.select();
      let ok = false;
      try { ok = !!(document.execCommand && document.execCommand('copy')); } catch (e) { ok = false; }
      feld.remove();
      return ok;
    }

    async function kopiereText(medium, karte, btn) {
      kartenFehler(karte, '');
      const vorher = btn ? btn.textContent : i18n('dashboard.contentHub.aktion.textKopieren');
      if (btn) { btn.disabled = true; btn.textContent = i18n('dashboard.contentHub.aktion.wirdGeholt'); }
      try {
        const text = await holeText(medium);
        const ok = await inZwischenablage(text);
        if (ok) {
          if (btn) btn.textContent = i18n('dashboard.contentHub.aktion.kopiert');
          clearTimeout(btn && btn._smChTimer);
          if (btn) btn._smChTimer = setTimeout(function () { btn.textContent = vorher; }, 2200);
          return;
        }
        // Die Zwischenablage hat sich verweigert (in Safari oft, weil die
        // Nutzergeste nach dem Laden verbraucht ist). Dann den Text ZEIGEN —
        // von Hand kopieren geht immer.
        oeffneTextModal(medium, text, i18n('dashboard.contentHub.text.autoKopierenVerweigert'));
        if (btn) btn.textContent = vorher;
      } catch (e) {
        kartenFehler(karte, i18n('dashboard.contentHub.text.ladenFehler', { fehler: (e.message || e) }));
        if (btn) btn.textContent = vorher;
      } finally {
        if (btn) btn.disabled = false;
      }
    }

    async function zeigeText(medium, karte) {
      kartenFehler(karte, '');
      oeffneTextModal(medium, '', '');
      if (textBody) textBody.textContent = i18n('dashboard.contentHub.text.laedt');
      try {
        const text = await holeText(medium);
        oeffneTextModal(medium, text, '');
      } catch (e) {
        if (textBody) textBody.textContent = '';
        if (textError) { textError.hidden = false; textError.textContent = i18n('dashboard.contentHub.text.ladenFehler', { fehler: (e.message || e) }); }
      }
    }

    function oeffneTextModal(medium, text, hinweis) {
      if (!textModal) return;
      offenerText = String(text || '');
      if (textTitle) textTitle.textContent = String(inhalt(medium.titel, medium.titel_en) || medium.dateiname || i18n('dashboard.contentHub.text.titel'));
      if (textMeta) {
        textMeta.textContent = [
          chBereichLabel({ nummer: medium.bereich_nummer, name: medium.bereich_name, name_en: medium.bereich_name_en }),
          chBytes(medium.groesse_bytes),
        ].join(' · ');
      }
      if (textBody) textBody.textContent = offenerText;
      if (textHint) textHint.hidden = true;
      if (textError) {
        textError.hidden = !hinweis;
        textError.textContent = hinweis || '';
      }
      textModal.hidden = false;
    }

    if (textModal) {
      textModal.querySelectorAll('[data-sm-ch-text-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          textModal.hidden = true;
          offenerText = '';
        });
      });
    }

    // ---- Die grosse Vorschau (08.10.2026) ------------------------------------
    //
    // Marcel: „Dass man sich die Bilder öffnen kann, sodass die auf dem Handy
    // oder auch auf dem Desktop angezeigt werden. Man möchte quasi eine
    // Vorschau sowohl vom Foto als auch vom Video."
    //
    // DER ABLAUF: Fenster auf (mit Spinner) -> Adresse holen -> src setzen ->
    // auf 'load'/'loadedmetadata' warten -> Spinner weg. Das Fenster geht
    // SOFORT auf und nicht erst nach der Antwort: ein Tipp, auf den eine
    // halbe Sekunde nichts passiert, wird am Handy wiederholt.

    // Merkt sich, wer das Fenster geoeffnet hat — der Fokus muss beim
    // Schliessen dorthin zurueck, sonst steht man mit der Tastatur am
    // Seitenanfang. Und das Medium, damit die Knoepfe im Fenster wissen,
    // worauf sie sich beziehen.
    let vorAusloeser = null;
    let vorMedium = null;

    function leereBuehne() {
      // 🔴 src WEGNEHMEN UND NICHT NUR AUSBLENDEN.
      //
      // Ein <video hidden> mit gesetztem src LAEDT WEITER. Wer ein 130-MB-Video
      // antippt, das Fenster nach zwei Sekunden schliesst und fuenf weitere
      // oeffnet, haette am Ende ein halbes Gigabyte vom Datenvolumen verbraucht
      // und nichts davon gesehen. pause() allein reicht nicht — es haelt die
      // Wiedergabe an, nicht den Abruf.
      //
      // load() nach dem Entfernen ist der Teil, den man vergisst: ohne den
      // Aufruf behaelt der Spieler seinen Puffer und laedt in Safari weiter.
      if (vorVideo) {
        try { vorVideo.pause(); } catch (e) { /* in Safari manchmal, egal */ }
        vorVideo.removeAttribute('src');
        try { vorVideo.load(); } catch (e) { /* dito */ }
        vorVideo.hidden = true;
      }
      if (vorBild) {
        vorBild.removeAttribute('src');
        vorBild.hidden = true;
      }
      zeige(vorSpinner, false);
    }

    function schliesseVorschau() {
      if (!vorModal) return;
      vorModal.hidden = true;
      leereBuehne();
      kartenFehler(vorPanel, '');
      fortschritt(vorPanel, null);
      vorMedium = null;
      // Zurueck auf das Bild, von dem aus geoeffnet wurde. Der Knopf kann
      // zwischenzeitlich weg sein (ein Filterwechsel baut das Raster neu) —
      // deshalb die Pruefung auf isConnected, sonst wirft focus() ins Leere.
      if (vorAusloeser && vorAusloeser.isConnected) vorAusloeser.focus();
      vorAusloeser = null;
    }

    // Die Knoepfe im Fenster. chAktionen ist dieselbe Funktion wie an der
    // Kachel — ein zweiter Wertevorrat hier wuerde beim naechsten Fall
    // auseinander laufen. 'textkopieren'/'textzeigen' koennen nicht
    // vorkommen (eine Vorschau gibt es nur fuer foto und video), werden aber
    // mitverdrahtet, damit die Zuordnung nicht luegt.
    function renderVorAktionen(medium) {
      if (!vorAktionen) return;
      vorAktionen.innerHTML = '<button type="button" class="sm-btn sm-btn-ghost"'
        + ' data-sm-ch-vorschau-close>' + i18n('dashboard.contentHub.aktion.schliessen') + '</button>'
        + chAktionen(medium, kannTeilen).map(function (a) {
          const stil = a.haupt ? 'sm-btn sm-btn-primary' : 'sm-btn sm-btn-ghost';
          return '<button type="button" class="' + stil + '"'
            + ' data-sm-ch-vaktion="' + escape(a.art) + '">'
            + escape(a.label) + '</button>';
        }).join('');

      vorAktionen.querySelectorAll('[data-sm-ch-vorschau-close]').forEach(function (btn) {
        btn.addEventListener('click', schliesseVorschau);
      });
      vorAktionen.querySelectorAll('[data-sm-ch-vaktion]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!vorMedium) return;
          const art = btn.getAttribute('data-sm-ch-vaktion');
          // 🔴 vorPanel ALS „KARTE". Fortschritt und Fehlermeldung landen damit
          // IM FENSTER und nicht auf der Kachel dahinter, wo sie verdeckt
          // waeren. Begruendung im Markup des Snippets.
          //
          // Die Nutzergeste ist hier frisch (ein Klick im Fenster) — das ist
          // der Grund, warum das Teilen aus dem Fenster heraus ueberhaupt
          // funktioniert und nicht erst beim zweiten Tipp.
          if (art === 'teilen') return teileMedium(vorMedium, vorPanel, btn);
          if (art === 'textkopieren') return kopiereText(vorMedium, vorPanel, btn);
          if (art === 'textzeigen') return zeigeText(vorMedium, vorPanel);
          return ladeHerunter(vorMedium, vorPanel, btn);
        });
      });
    }

    async function oeffneVorschau(medium, auslöser) {
      if (!vorModal || !chHatVorschau(medium)) return;
      vorAusloeser = auslöser || null;
      vorMedium = medium;

      leereBuehne();
      kartenFehler(vorPanel, '');
      fortschritt(vorPanel, null);
      if (vorTitel) vorTitel.textContent = String(inhalt(medium.titel, medium.titel_en) || medium.dateiname || i18n('dashboard.contentHub.vorschau.titel'));
      if (vorMeta) {
        vorMeta.textContent = [
          chBereichLabel({ nummer: medium.bereich_nummer, name: medium.bereich_name, name_en: medium.bereich_name_en }),
          chTypLabel(medium.medientyp),
          chBytes(medium.groesse_bytes),
        ].join(' · ');
      }
      renderVorAktionen(medium);
      vorModal.hidden = false;
      zeige(vorSpinner, true);

      let adresse;
      try {
        adresse = await chFetch(medium.vorschau_pfad);
      } catch (e) {
        zeige(vorSpinner, false);
        kartenFehler(vorPanel, i18n('dashboard.contentHub.vorschau.ladenFehler', { fehler: (e.message || e) }));
        return;
      }
      // Zwischen Tipp und Antwort kann das Fenster schon wieder zu sein, oder
      // ein anderes Medium offen. Dann gehoert diese Adresse nicht mehr hierher.
      if (vorModal.hidden || !vorMedium || String(vorMedium.id) !== String(medium.id)) return;
      if (!adresse || !adresse.url) {
        zeige(vorSpinner, false);
        kartenFehler(vorPanel, i18n('dashboard.contentHub.vorschau.keineAdresse'));
        return;
      }

      const istVideo = String(medium.medientyp || '') === 'video';
      const el = istVideo ? vorVideo : vorBild;
      if (!el) { zeige(vorSpinner, false); return; }

      // 🔴 DIE FEHLERBEHANDLUNG IST KEIN BEIWERK. Die signierte Adresse gilt
      // 15 Minuten; wer ein Video pausiert, telefoniert und danach weiterspult,
      // laeuft in einen abgelaufenen Range-Request. Ohne 'error'-Zuhoerer
      // bleibt die Flaeche dann einfach schwarz, und die Beraterin haelt den
      // Hub fuer kaputt. Mit ihm steht da, was zu tun ist.
      el.onerror = function () {
        zeige(vorSpinner, false);
        kartenFehler(
          vorPanel,
          istVideo
            ? i18n('dashboard.contentHub.vorschau.videoFehler')
            : i18n('dashboard.contentHub.vorschau.bildFehler'),
        );
      };
      // Bei einem Video reicht 'loadedmetadata' — dann stehen Laenge und erstes
      // Bild, und der Spinner hat seine Aufgabe getan. Auf 'canplaythrough' zu
      // warten hiesse, bei 130 MB minutenlang einen Spinner zu zeigen.
      const fertig = function () { zeige(vorSpinner, false); };
      if (istVideo) el.onloadedmetadata = fertig; else el.onload = fertig;

      el.hidden = false;
      el.src = adresse.url;
    }

    if (vorModal) {
      vorModal.querySelectorAll('[data-sm-ch-vorschau-close]').forEach(function (el) {
        el.addEventListener('click', schliesseVorschau);
      });
      // Escape schliesst. Der Zuhoerer haengt am Dokument und nicht am Fenster:
      // wer gerade im Video-Spieler steckt, hat den Fokus in einem
      // Schattenbaum, und ein keydown dort erreicht das Fenster nicht.
      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && !vorModal.hidden) schliesseVorschau();
      });
    }
    if (textCopy) {
      textCopy.addEventListener('click', async function () {
        if (!offenerText) return;
        const ok = await inZwischenablage(offenerText);
        if (textHint) textHint.hidden = !ok;
        if (!ok && textError) {
          textError.hidden = false;
          textError.textContent = i18n('dashboard.contentHub.text.kopierenVerweigert');
        }
      });
    }

    // ---- Laden ----
    async function ladeStruktur() {
      try {
        // chAbfrage mit leerem Filter baut hier nur den Rollenteil — bei
        // 'berater' ist das eine leere Zeichenkette und die Adresse damit
        // dieselbe wie vor dem 09.10.2026. Begruendung bei chAbfrage.
        const daten = await chFetch('/api/content/struktur' + chAbfrage({}, ROLLE));
        struktur = {
          bereiche: (daten && daten.bereiche) || [],
          tags: (daten && daten.tags) || [],
          produkte: (daten && daten.produkte) || [],
          // 🔴 medientypen MUSS hier mitgetragen werden. Bis zum 08.10.2026
          // fehlte es in diesem Objekt — die Antwort des Workers enthielt es,
          // aber chAchsen bekam undefined und gab `arten: []` zurueck. Folge:
          // der Art-Filter erschien NIRGENDS, auch nicht in den Bereichen, wo
          // er laut Gliederung stehen sollte. Marcels „bitte ueberall Filter
          // mit Video/Foto hinzunehmen" betraf also nicht nur die
          // Einstiegsseite, sondern eine Leiste, die ueberhaupt nie da war.
          medientypen: (daten && daten.medientypen) || [],
        };
      } catch (e) {
        // Ohne Struktur bleibt die Bereichsleiste leer — die Liste selbst
        // funktioniert trotzdem, denn ohne Filter liefert /medien alles. Die
        // Art-Leiste bleibt ueber den Rueckfall CH_ARTEN bedienbar.
        struktur = { bereiche: [], tags: [], produkte: [], medientypen: [] };
      }
      renderBereiche();
      renderFilter();
    }

    async function ladeMedien() {
      zeige(loadingEl, true);
      zeige(errorEl, false);
      zeige(emptyEl, false);
      zeige(noteEl, false);
      gridEl.innerHTML = '';
      try {
        const daten = await chFetch('/api/content/medien' + chAbfrage(filter, ROLLE));
        medien = (daten && daten.medien) || [];
        const note = chListenNote(daten);
        if (note && noteEl) { noteEl.hidden = false; noteEl.textContent = note; }
        if (medien.length === 0) {
          const leer = chLeerText(filter);
          if (emptyTitle) emptyTitle.textContent = leer.titel;
          if (emptyText) emptyText.textContent = leer.text;
          zeige(emptyEl, true);
        } else {
          renderMedien();
        }
      } catch (e) {
        medien = [];
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = i18n('dashboard.contentHub.liste.ladenFehler', { fehler: (e.message || e) });
        }
      } finally {
        zeige(loadingEl, false);
      }
    }

    ladeStruktur();
    ladeMedien();
  }

  // Reine Helfer fuer den Standalone-Test
  // (node theme/assets/test/contenthub.test.mjs).
  window.__sm_contenthub = {
    CH_TEILBAR,
    CH_TEXT_ENDUNGEN,
    CH_TEXT_MAX_BYTES,
    CH_ARTEN,
    chIstProduktBereich,
    chIstPrintBereich,
    chZeigtTitel,
    chHatVorschau,
    chArtenFuer,
    chZeigtArtLeiste,
    chEndung,
    chMimeTyp,
    chBytes,
    chTypLabel,
    chPlatzhalter,
    chBereichLabel,
    chHatInhalt,
    chTextLesbar,
    chTeilbar,
    chAktionen,
    chAchsen,
    chArtLabel,
    chAbfrage,
    chListenNote,
    chFortschrittText,
    chFortschrittProzent,
    chLeerText,
    chBrowserKannDateienTeilen,
  };

  // =========================================================================
  // DER EINSTIEG
  // =========================================================================
  window.SmContentHub = {
    /**
     * Baut den Content-Hub in das uebergebene Element.
     *
     * @param {Element} pane      das Element mit dem Markup (data-sm-ch)
     * @param {object}  optionen
     * @param {string}  optionen.workerBase  Adresse des provision-worker
     * @param {string} [optionen.rolle]      'berater' (Vorgabe) | 'studio'
     */
    init(pane, optionen) {
      const o = optionen || {};
      // 🔴 OHNE ADRESSE WIRD NICHTS GEBAUT, und es wird GESAGT. Ein Reiter, der
      // lautlos leer bleibt, sieht wie fehlendes Material aus — und genau
      // danach wuerde dann im Admin gesucht.
      if (!o.workerBase) {
        console.error('[content-hub] Ohne workerBase kann der Reiter nicht laden. '
          + 'Der Aufruf muss die Adresse des provision-worker mitgeben.');
        return;
      }
      PROVISION_WORKER_BASE = String(o.workerBase);
      // Alles ausser 'studio' ist 'berater' — dieselbe sichere Richtung wie in
      // leseRolle im Worker: ein Tippfehler fuehrt zur vollen Liste und nicht
      // zu einem halb leeren Dashboard.
      ROLLE = String(o.rolle || '') === 'studio' ? 'studio' : 'berater';
      initContentHub(pane);
    },
  };
})();
